<template>
    <div id="app">
        <yetkidialog ref="yetkidialog"></yetkidialog>
            <loadingcomp
          ref="loadingcomp"
          v-bind:mesaj="loadingmesaj"
          v-model="loadingdialog"
        ></loadingcomp>
        <v-card flat color="grey lighten-5">
            <v-layout row wrap>
                <v-flex xs12 sm12>
                    <v-toolbar size="120px" dark color="info">
                        <v-toolbar-title>{{ $t('Ticket-List') }}</v-toolbar-title>
                        <v-spacer></v-spacer>
    
                        <v-flex xs12 sm3 md3>
                            <v-text-field flat="" prepend-inner-icon="live_help" id="searchtext" maxlength="50" @keyup="searchliste = $event.target.value" ref="searchtext" @keyup.enter="biletara(searchliste)" solo-inverted="" hide-details :label="$t('Search')" @click:append="biletarasearch()" :append-icon="searchIcon">
                                <v-tooltip slot="prepend-inner" bottom>
                                    <v-icon slot="activator" color="primary" dark>live_help</v-icon>
                                    <span> {{ $t('Fields-Which-Can-be-Searched') }} </span><br />
                                    <v-divider color="yellow"></v-divider>
                                    <template v-for="item in aramatipi">
                                        <span :key="item.id">{{item.text}}</span><br />
                                    </template>
                                </v-tooltip>
                            </v-text-field>
                        </v-flex>
    
                        <v-tooltip bottom>
                            <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="yenikayit()" flat> <span class="hidden-sm-and-down"> {{ $t('New') }}
                                </span>
                                <v-icon right dark>add_box</v-icon>
                            </v-btn>
                            <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                            <span v-if="sayfayetki.Save"> {{ $t('New') }} </span>
                        </v-tooltip>
    
                        <v-menu bottom left>
                            <v-btn slot="activator" dark icon>
                                <v-icon>more_vert</v-icon>
                            </v-btn>
                            <v-list>
                                <v-tooltip bottom>
                                    <v-list-tile slot="activator" :disabled="!sayfayetki.Update" @click="carikontrol()">
                                        <v-list-tile-title> {{ $t('Change-Current-Code') }} </v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update"> {{ $t('Change-Current-Code') }} </span>
                                </v-tooltip>
    
                                <v-tooltip bottom>
                                    <v-list-tile slot="activator" :disabled="!sayfayetki.Update" @click="gecicicarikontrol()">
                                        <v-list-tile-title>{{$t('Change-Temporary-Current-Code')}}</v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update">{{$t('Change-Temporary-Current-Code')}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <v-list-tile slot="activator" :disabled="!sayfayetki.Update" @click="voidkontrol()">
                                        <v-list-tile-title>{{ $t('Make-it-Void') }}</v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update">{{ $t('Make-it-Void') }}</span>
                                </v-tooltip>
    
                                <v-tooltip bottom>
                                    <v-list-tile slot="activator" :disabled="!sayfayetki.Update" @click="iadekontrol()">
                                        <v-list-tile-title>{{$t('Transaction-Invoice-No-Received')}}</v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update">{{$t('Transaction-Invoice-No-Received')}}</span>
                                </v-tooltip>
    
                                <v-tooltip bottom>
                                    <v-list-tile slot="activator" :disabled="!sayfayetki.Update" @click="alisFaturaNokontrol()">
                                        <v-list-tile-title>{{$t('Buying-Invoice-No-Transaction')}}</v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update">{{$t('Buying-Invoice-No-Transaction')}}</span>
                                </v-tooltip>
    
                                <v-tooltip bottom>
                                    <v-list-tile slot="activator" :disabled="!sayfayetki.Update" @click="sirketDegistirControl()">
                                        <v-list-tile-title>{{$t('Change-Company')}}</v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update">{{$t('Change-Company')}}</span>
                                </v-tooltip>
    
                                 <v-tooltip bottom>
                                    <v-list-tile slot="activator" :disabled="!sayfayetki.Update" @click="sirketeKopyalaControl()">
                                        <v-list-tile-title>{{ $t('Şirkete Kopyala') }}</v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update">{{$t('Change-Company')}}</span>
                                </v-tooltip>
                                                         
                                <v-list-tile  @click="BiletExcelListele(1,'SalesDate',50,false)">
                                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                                </v-list-tile>

                                <v-list-tile @click="bulkPdfDialog = true">
                                    <v-list-tile-title>Toplu PDF İndir</v-list-tile-title>
                                </v-list-tile>
    
                            </v-list>
                        </v-menu>
                    </v-toolbar>
                </v-flex>
                <v-flex xs12 sm12>
    
                    <v-form ref="formbiletrapor" v-model="valid" lazy-validation>
                        <v-container fluid="">
                            <v-card flat>
                                <v-layout row wrap="">
                                    <v-flex xs12 sm4 md2>
                                        <tarihim :etiket="$t('Starting-Date')" :detaygizle="false" v-model="date" v-bind:defaultvalue="'ok'" :rules="[v => !!v || $t('Please-select-a-date')]">
                                        </tarihim>
                                    </v-flex>
                                    <v-flex xs12 sm4 md2>
                                        <tarihim :etiket="$t('Finishing-Date')" :detaygizle="false" v-model="date2" v-bind:defaultvalue="'ok'" :rules="[v => !!v || $t('Please-select-a-date')]">
                                        </tarihim>
                                    </v-flex>
    
                                    <v-flex xs12 sm2 md2>
                                        <v-select hide-details="" :items="itemstip" :label="$t('Ticket-Type')" item-text="text" v-model="ListInput.Filtreler.BiletTipi" item-value="value">
                                        </v-select>
                                    </v-flex>
                                    <v-flex xs12 sm2 md2>
                                        <v-layout>
                                            <div v-if="load1">
                                                <v-btn color="info" @click="BiletListele(1,'SalesDate',50,false)" fab small="" dark>
    
                                                    <v-icon>search</v-icon>
                                                </v-btn>
                                            </div>
                                            <div v-if="!load1">
                                                <v-layout fill-height="" align-center="">
                                                    <v-progress-circular indeterminate color="primary">
                                                    </v-progress-circular>
                                                </v-layout>
                                            </div>
    
                                            <v-badge color="white" :overlap="true">
                                                <template v-slot:badge>
                                                    <v-icon v-if="filtrevarmi" large color="green">
                                                        check_circle_outline </v-icon>
                                                </template>
    
                                                <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()" color="info" fab dark>
                                                    <v-icon>filter_list</v-icon>
                                                </v-btn>
                                                <v-tooltip bottom="" :activator="el" v-model="tooltip">
                                                    <span>{{$t('Add-Search-Filter')}}</span>
                                                </v-tooltip>
    
                                            </v-badge>
    
                                        </v-layout>
                                    </v-flex>
    
                                    <v-flex xs12 sm0 md1>
                                    </v-flex>
    
                                    <v-flex xs12 sm5 md3>
                                        <v-text-field
                                            :label="$t('Ticket-Number')"
                                            v-model="searchNo"
                                        >
                                            <template v-slot:append-outer>
                                                <v-icon color="info" @click="searchTicketNo()">send</v-icon>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
    
                                </v-layout>
                                
                            </v-card>
                        </v-container>
                    </v-form>
                </v-flex>
    
                <v-layout row justify-center>
                    <v-dialog v-model="sirketDegistirFiltre" persistent max-width="290">
                        <v-card>
                            <v-card-title class="headline">Filtre Seçimi</v-card-title>
                            <v-card-text>
                                <v-chip  color="primary" text-color="white">
                                    <v-avatar>
                                        <v-icon color="red">cancel</v-icon>
                                    </v-avatar>
                                    Sadece Faturalanmamış Kayıtlar
                                </v-chip>
                                        <v-select hide-details="" :items="itemstipforCompanyChange" :label="$t('Ticket-Type')" item-text="text" v-model="ListInput.Filtreler.BiletTipi" item-value="value">
                                        </v-select>                            
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" flat @click.native="sirketDegistirFiltre = false"> {{ $t('cancel_button') }} </v-btn>
                                <v-btn color="primary" flat @click="filtrekayit()">{{ $t('Apply') }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-layout>
      <v-layout row justify-center>
                    <v-dialog v-model="sirketeKopyalaFiltre" persistent max-width="290">
                        <v-card>
                            <v-card-title class="headline">Filtre Seçimi</v-card-title>
                            <v-card-text>
                                <v-chip  color="primary" text-color="white">
                                    <v-avatar>
                                        <v-icon color="red">cancel</v-icon>
                                    </v-avatar>
                                    Sadece Faturalanmamış Kayıtlar
                                </v-chip>
                                        <v-select hide-details="" :items="itemstipforCompanyChange" :label="$t('Ticket-Type')" item-text="text" v-model="ListInput.Filtreler.BiletTipi" item-value="value">
                                        </v-select>                            
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" flat @click.native="sirketeKopyalaFiltre = false"> {{ $t('cancel_button') }} </v-btn>
                                <v-btn color="primary" flat @click="filtrekayit()">{{ $t('Apply') }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-layout>
                <v-dialog v-model="dialogfiltre" persistent="" scrollable="" max-width="550px">
                    <v-card color="grey lighten-5">
    
                        <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <div class="d-flex align-center mb-3">
                             <span class="mr-4">{{ $t('Filter-selection') }}</span>
                              <v-radio-group
                                 v-model="ListInput.Filtreler.BiletAcenteTipi"
                                   row
                                    hide-details
                                     class="ma-0 pa-0"
                                          >
                                   <v-radio :value="0" :label="$t('All')" />
                                   <v-radio :value="1" :label="$t('Agency')" />
                                   <v-radio :value="2" :label="$t('Direct')" />
                             </v-radio-group>
                         </div>
    
                            <v-flex xs12 sm12 md12 style=" padding-bottom:10px;">
                                <v-card class="white--text">
                                    <v-card color="grey lighten-5" flat="">
                                        <v-card-actions>
    
                                            <v-layout row="" wrap="">
    
                                                <v-flex xs12 v-if="filtreUyarimesaj" sm12 md12>
                                                    <v-layout align-start="" justify-start="" fill-height="">
                                                        <v-icon color="red">warning</v-icon> &nbsp;
                                                        <span class="subheading red--text font-weight-">
                                                          {{ $t('continue-with-Apply-Filters-option') }}
                                                        </span>
                                                    </v-layout>
                                                </v-flex>
    
                                                <v-flex xs12 pt-2 sm12 md12>
                                                    <v-layout v-if="filtrecaridegistirView || filtreiadekontrolView" align-center="">
                                                        <span class="subheading grey--text font-weight-">
                                                            <ul>
                                                                <li> {{ $t('Current-Account-Selection') }} &nbsp;
                                                                </li>
                                                            </ul>
                                                        </span>
                                                        <v-icon v-show="cariOnay" color="green">
                                                            check</v-icon>
                                                        <v-icon v-show="!cariOnay" color="red">
                                                            close</v-icon>
                                                    </v-layout>
                                                    <v-layout v-if="filtrecaridegistirView || filtregecicicaridegistirView || filtrevoidyapView" align-center="">
                                                        <span class="subheading grey--text font-weight-">
                                                            <ul>
                                                                <li>{{ $t('Ticket-Type') }} : {{$t('Sales')}} &nbsp;
                                                                </li>
                                                            </ul>
                                                        </span>
                                                        <v-icon v-show="bilettipisatisOnay" color="green">
                                                            check</v-icon>
                                                        <v-icon v-show="!bilettipisatisOnay" color="red">
                                                            close</v-icon>
                                                    </v-layout>
                                                    <v-layout v-if="filtrealisfaturaView" align-center="">
                                                        <span class="subheading grey--text font-weight-">
                                                            <ul>
                                                                <li>{{ $t('Ticket-Type-Sales-or-Return') }}  &nbsp;
                                                                </li>
                                                            </ul>
                                                        </span>
                                                        <v-icon v-show="bilettipisatisiadeOnay" color="green">
                                                            check</v-icon>
                                                        <v-icon v-show="!bilettipisatisiadeOnay" color="red">
                                                            close</v-icon>
                                                    </v-layout>
    
                                                    <v-layout v-if="filtrealisfaturaView" align-center="">
                                                        <span class="subheading grey--text font-weight-">
                                                            <ul>
                                                                <li>{{$t('Buying-Invoice-Type')}}: {{$t('Without-Invoice-Received')}} &nbsp;
                                                                </li>
                                                            </ul>
                                                        </span>
                                                        <v-icon v-show="acentefatnoOnay" color="green">
                                                            check</v-icon>
                                                        <v-icon v-show="!acentefatnoOnay" color="red">
                                                            close</v-icon>
                                                    </v-layout>
    
                                                    <v-layout v-if="filtreiadekontrolView" align-center="">
                                                        <span class="subheading grey--text font-weight-">
                                                            <ul>
                                                                <li> {{ $t('Ticket-Type') }} : {{$t('Refund')}} &nbsp;
                                                                </li>
                                                            </ul>
                                                        </span>
                                                        <v-icon v-show="bilettipiiadeOnay" color="green">
                                                            check</v-icon>
                                                        <v-icon v-show="!bilettipiiadeOnay" color="red">
                                                            close</v-icon>
                                                    </v-layout>
                                                    <v-layout v-if="filtreiadekontrolView" align-center="">
                                                        <span class="subheading grey--text font-weight-">
                                                            <ul>
                                                                <li>{{$t('Show-Items-with-Receipts-Printed')}} &nbsp;
                                                                </li>
                                                            </ul>
                                                        </span>
                                                        <v-icon v-show="dekontbasilanOnay" color="green">
                                                            check</v-icon>
                                                        <v-icon v-show="!dekontbasilanOnay" color="red">
                                                            close</v-icon>
                                                    </v-layout>
                                                    <v-layout v-if="filtreiadekontrolView" align-center="">
                                                        <span class="subheading grey--text font-weight-">
                                                            <ul>
                                                                <li>{{$t('Refund-Document-Type')}}: {{ $t('Receipt') }} &nbsp;
                                                                </li>
                                                            </ul>
                                                        </span>
                                                        <v-icon v-show="iadebelgedekontOnay" color="green">
                                                            check</v-icon>
                                                        <v-icon v-show="!iadebelgedekontOnay" color="red">
                                                            close</v-icon>
                                                    </v-layout>
                                                    <v-layout v-if="filtreiadekontrolView" align-center="">
                                                        <span class="subheading grey--text font-weight-">
                                                            <ul>
                                                                <li>{{$t('Show-No-Refund-Invoice-Received')}} &nbsp;
                                                                </li>
                                                            </ul>
                                                        </span>
                                                        <v-icon v-show="iadefaturasigelmeyenOnay" color="green">
                                                            check</v-icon>
                                                        <v-icon v-show="!iadefaturasigelmeyenOnay" color="red">
                                                            close</v-icon>
                                                    </v-layout>
                                                    <v-layout v-if="filtrecaridegistirView || filtregecicicaridegistirView || filtrevoidyapView" align-center="">
                                                        <span class="subheading grey--text font-weight-">
                                                            <ul>
                                                                <li>{{ $t('Invoice-Type') }} : {{ $t('Not-invoiced-Ones') }} &nbsp;
                                                                </li>
                                                            </ul>
                                                        </span>
                                                        <v-icon v-show="faturatipifaturalanmamislarOnay" color="green">
                                                            check</v-icon>
                                                        <v-icon v-show="!faturatipifaturalanmamislarOnay" color="red">
                                                            close</v-icon>
                                                    </v-layout>
                                                    <v-layout v-if="filtregecicicaridegistirView" align-center="">
                                                        <span class="subheading grey--text font-weight-">
                                                            <ul>
                                                                <li>{{ $t('Direction-Selection') }} &nbsp;
                                                                </li>
                                                            </ul>
                                                        </span>
                                                        <v-icon v-show="tekhattpiiOnay" color="green">
                                                            check</v-icon>
                                                        <v-icon v-show="!tekhattpiiOnay" color="red">
                                                            close</v-icon>
                                                    </v-layout>
                                                    <v-layout v-if="filtregecicicaridegistirView" align-center="">
                                                        <span class="subheading grey--text font-weight-">
                                                            <ul>
                                                                <li>{{ $t('Current-Type') }} : {{$t('Only-Temporary-Currents')}} &nbsp;
                                                                </li>
                                                            </ul>
                                                        </span>
                                                        <v-icon v-show="gecicarilerOnay" color="green">
                                                            check</v-icon>
                                                        <v-icon v-show="!gecicarilerOnay" color="red">
                                                            close</v-icon>
                                                    </v-layout>
    
                                                </v-flex>
    
                                                <v-flex xs12 sm12 md12>
                                                    <v-text-field hide-details="" autofocus="" v-model="ListInput.BiletNo" mask="##########" :label="$t('Ticket-Number')">
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <cariaracomp v-bind:etiket="$t('Currentcode_label')" v-bind:value="ListInput.Filtreler.CariKod" :loading="loading" v-model="ListInput.Filtreler.CariKod" :Coper="false"></cariaracomp>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-autocomplete hide-details="" clearable :items="itemsairlinelist" :label="$t('Select-Airline')" multiple item-text="Title" v-model="ListInput.Filtreler.Havayollari" item-value="HavaYoluKodu">
                                                        <template slot="selection" slot-scope="{ item, index }">
                                                            <div v-if="index === 0">
                                                                <span>{{ item.HavaYoluKodu }}</span>
                                                            </div>
                                                            <span v-if="index === 1" class="grey--text caption">(+{{
                                                                    ListInput.Filtreler.Havayollari.length -
                                                                    1
                                                                    }} {{ $t('Other') }} )</span>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-flex>
    
                                                <v-flex xs12 sm6>
                                                    <v-select hide-details="" :items="itemstip" :label="$t('Ticket-Type')" item-text="text" v-model="ListInput.Filtreler.BiletTipi" item-value="value">
                                                    </v-select>
                                                </v-flex>
    
                                                <v-layout row="" wrap="">
    
                                                    <v-flex xs12 v-if="!filtregecicicaridegistirView" sm6 md6>
                                                        <v-layout justify-space-between column>
                                                            <v-select hide-details="" clearable="" :items="itemsyon" :label="$t('Direction-Selection')" multiple item-text="text" v-model="ListInput.Filtreler.HatTipi" item-value="value">
                                                                <template slot="selection" slot-scope="{ item, index }">
                                                                    <div v-if="index === 0">
                                                                        <span>{{ item.text }}</span>
                                                                    </div>
                                                                    <span v-if="index === 1" class="grey--text caption">(+{{
                                                                            ListInput.Filtreler.HatTipi.length -
                                                                            1
                                                                            }} {{ $t('Other') }}  )</span>
                                                                </template>
                                                            </v-select>
                                                        </v-layout>
                                                    </v-flex>
    
                                                    <v-flex xs12 v-if="filtregecicicaridegistirView" sm6 md6>
                                                        <v-layout justify-space-between column>
                                                            <v-select hide-details="" clearable="" :items="itemsyon" :label="$t('Direction-Selection')" item-text="text" v-model="ListInput.Filtreler.HatTipi" item-value="value">
    
                                                            </v-select>
                                                        </v-layout>
                                                    </v-flex>
    
                                                    <v-flex xs12 xs6 sm6>
                                                        <v-autocomplete hide-details="" clearable :items="itemsparkur" :label="$t('Track-selection')" multiple item-text="Title" v-model="ListInput.Filtreler.Parkurlar" item-value="ParkurKod">
                                                            <template slot="selection" slot-scope="{ item, index }">
                                                                <div v-if="index === 0">
                                                                    <span>{{ item.Aciklama }}</span>
                                                                </div>
                                                                <span v-if="index === 1" class="grey--text caption">(+{{
                                                                    ListInput.Filtreler.Parkurlar.length -
                                                                    1
                                                                    }} {{ $t('Other') }} )</span>
                                                            </template>
                                                        </v-autocomplete>
                                                    </v-flex>
    
                                                </v-layout>
    
                                                <v-layout>
                                                    <v-flex xs12 sm6>
                                                        <v-autocomplete clearable :items="itemsparkur" hide-details="" :label="$t('Flight-Departure')" item-text="Title" v-model="ListInput.Filtreler.Ucus1" item-value="ParkurKod">
                                                        </v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-autocomplete clearable :items="itemsparkur" hide-details="" :label="$t('Flight-Arrival')" item-text="Title" v-model="ListInput.Filtreler.Ucus2" item-value="ParkurKod">
                                                        </v-autocomplete>
                                                    </v-flex>
    
                                                </v-layout>
                                                <v-flex xs12 sm12>
                                                    <v-text-field :label="$t('Ticket-Agent')" hide-details="" v-model="ListInput.Filtreler.KesenKisi"></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm12>
                                                    <masrafmerkezicomp v-model="ListInput.Filtreler.MasrafMerkezi"></masrafmerkezicomp>
                                                </v-flex>
                                                <v-flex v-if="!simpleMode" xs12 sm6>
                                                    <v-autocomplete :items="bankapositems" hide-datails tabindex="57" hide-details="" v-model="ListInput.Filtreler.PosKod" item-text="Title" item-value="PosKodu" clearable :label="$t('POS-Selection')"></v-autocomplete>
                                                </v-flex>
                                                <v-flex  v-if="!simpleMode" xs12 sm6>
                                                    <kredikartcomp :tabdeger="'63'" v-model="ListInput.Filtreler.KrediKartNo"></kredikartcomp>
                                                </v-flex>
    
                                                <v-flex xs12 sm6>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Initial-Amount')" v-model="ListInput.Filtreler.BaslangicTutar" :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Final-Amount')" v-model="ListInput.Filtreler.BitisTutar" :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field label="PNR No" hide-details="" v-model="ListInput.Filtreler.PnrNo"></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field :label="$t('Name-of-Passenger')" hide-details="" v-model="ListInput.Filtreler.YolcuAdi"></v-text-field>
                                                </v-flex>
    
                                                <v-flex pa-1 xs12 sm12 md12>
                                                    <v-card flat="" color="#9E9E9E">
                                                        <v-card-title>
                                                            <span class="subheading white--text font-weight-medium ">{{$t('Options')}}</span>
                                                        </v-card-title>
                                                    </v-card>
                                                </v-flex>
    
                                                <v-flex xs12 sm6>
    
                                                    <v-radio-group v-if="!simpleMode" v-model="ListInput.Filtreler.TutarTip" :label="$t('Amount-Type')" hide-details>
                                                        <v-radio :value="0" :label="$t('Net-Amount')"></v-radio>
                                                        <v-radio :value="1" :label="$t('Ticket-Amount')"></v-radio>
                                                        <v-radio :value="2" :label="$t('Service-Amount')"></v-radio>
                                                        <v-radio :value="3" :label="$t('Discount-Amount')"></v-radio>
                                                    </v-radio-group>
    
                                                </v-flex>
    
                                                <div v-if="!simpleMode" class="flex md6">
                                                    <v-radio-group v-model="ListInput.Filtreler.GiderPusulasi" :label="$t('Refund-Document-Type')" hide-details>
                                                        <v-radio :value="0" :label="$t('No-Selection')"></v-radio>
                                                        <v-radio :value="1" :label="$t('Note-of-Expenses')"></v-radio>
                                                        <v-radio :value="2" :label="$t('Receipt')"></v-radio>
                                                    </v-radio-group>
                                                </div>
    
                                                <div class="flex md6">
                                                    <v-radio-group v-model="ListInput.Filtreler.AcentaFatNo" :label="$t('Buying-Invoice-Type')" hide-details>
                                                        <v-radio :value="0" :label="$t('No-Selection')"></v-radio>
                                                        <v-radio :value="1" :label="$t('With-Invoice-Received')"></v-radio>
                                                        <v-radio :value="2" :label="$t('Without-Invoice-Received')"></v-radio>
                                                    </v-radio-group>
                                                </div>
    
                                                <div class="flex md6">
                                                    <v-radio-group v-model="ListInput.Filtreler.FaturaStatus" :label="$t('Invoice-Type')" hide-details>
                                                        <v-radio :value="0" :label="$t('No-Selection')"></v-radio>
                                                        <v-radio :value="1" :label="$t('Not-invoiced-Ones')"></v-radio>
                                                        <v-radio :value="2" :label="$t('Import-Accounting-Code')"></v-radio>
                                                        <v-radio :value="3" :label="$t('Items-Not-to-be-Invoiced')"></v-radio>
    
                                                    </v-radio-group>
                                                </div>
    
                                                <div class="flex md6">
                                                    <v-radio-group v-model="ListInput.Filtreler.GeciciCari" :label="$t('Current-Type')" hide-details>
                                                        <v-radio :value="0" :label="$t('No-Selection')"></v-radio>
                                                        <v-radio :value="1" :label="$t('Excluding-Temporary-Currents')"></v-radio>
                                                        <v-radio :value="2" :label="$t('Only-Temporary-Currents')"></v-radio>
                                                    </v-radio-group>
                                                </div>
                                                <div class="flex md12">
                                                    <v-checkbox v-model="ListInput.Filtreler.IadeFatura" :label="$t('Show-No-Refund-Invoice-Received')" hide-details="">
                                                    </v-checkbox>
                                                </div>
                                                  <div class="flex md12">
                                                    <v-checkbox v-model="ListInput.Filtreler.SifirTutarGosterme" :label="$t('Showing-Tickets-with-Zero-Amounts')" hide-details="">
                                                    </v-checkbox>
                                                </div>
                                                <div v-if="!simpleMode" class="flex md12">
                                                    <v-checkbox hide-details v-model="ListInput.Filtreler.DekontBas" :label="$t('Show-Items-with-Receipts-Printed')">
                                                    </v-checkbox>
                                                </div>
                                                    <div v-if="!simpleMode" class="flex md12">
                                                    <v-checkbox v-model="ListInput.Filtreler.RezVerenBosGoster" :label="$t('Show-Empty-Rooms-for-Reservation')" hide-details="">
                                                    </v-checkbox>
                                                </div>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click="filtreiptal()">{{ $t('Remove-Filters') }}</v-btn>
                            <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
    
                <v-dialog v-model="dialogcarikoddegistir" v-if="dialogcarikoddegistir" scrollable="" persistent="" max-width="500px">
                    <v-card color="grey lighten-5">
    
                        <v-card-title> {{$t('Change-Current-Code')}} </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
    
                            <v-layout row="" wrap="">
                                <v-flex xs12 sm12 md12>
                                    <!-- <v-autocomplete hide-details clearable="" label="Cari Seçiniz" append-icon="search"
                                            autocomplete :loading="loading" :items="statecariyeni" item-text="text"
                                            cache-items="" v-model="yenicari" item-value="id"
                                            :search-input.sync="yenicarisearch"></v-autocomplete> -->
                                </v-flex>
    
                            </v-layout>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click.native="dialogcarikoddegistir=false">{{$t("cancel_button")}}</v-btn>
                            <v-btn color="blue darken-1" flat @click.native="carisor()"> {{ $t('Change-Current-Code') }} </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
    
                <v-dialog v-model="gecicicaridialog" v-if="gecicicaridialog" persistent="" scrollable="" max-width="500px">
                    <v-card color="grey lighten-5">
    
                        <v-card-title> {{ $t('Transferring-Tickets-Temporary-Account-Current-One') }} </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-flex pa-1 xs12 sm12 md12>
                                <v-card class="white--text">
                                    <v-card color="grey lighten-4" flat="">
                                        <v-card-actions>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm12 md12>
                                                    <cariaracomp v-bind:etiket="$t('Select-Current-Account')" v-bind:value="geciciyenicari" :loading="loadinggecici" 
                                                    v-model="geciciyenicari" ></cariaracomp>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
    
                                                    <v-text-field :label="$t('Ticket-Agent')" v-model="GeciciCari.KesenKisi" hide-details=""></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
    
                                                    <masrafmerkezicomp v-model="GeciciCari.Masraf" :etiket="$t('Expense-Center-v2')"></masrafmerkezicomp>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
    
                                                    <referansmerkezicomp :coper="false" v-model="GeciciCari.Referans" :etiket="$t('Reference-Centre')"></referansmerkezicomp>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field :label="this.$t('Res-given')" v-model="GeciciCari.RezervasyonVeren" hide-details="">
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field :label="this.$t('Res-giving')"  v-model="GeciciCari.RezervasyonAlan" hide-details=""></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
    
                                                    <v-select hide-details="" v-model="GeciciCari.SatisSekli" :items="satissekliitem" item-text="text" item-value="value" clearable :label="$t('Sales-Method')"></v-select>
                                                </v-flex>
                                                <div v-if="kredikartshow">
    
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md6>
                                                            <kredikartcomp :tabdeger="'63'" v-model="GeciciCari.KrediKartNo"></kredikartcomp>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md6>
                                                            <v-select :items="karttipi" hide-details="" v-model="GeciciCari.KKCins" clearable :label="$t('Credit-Card-Type-v2')" item-text="text" item-value="id"></v-select>
                                                        </v-flex>
                                                    </v-layout>
    
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md6>
    
                                                            <v-select hide-details="" :items="sonkullanimAy" v-model="GeciciCari.KKAy" clearable :label="$t('Expiry-Month')" item-text="text" item-value="id"></v-select>
    
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md6>
                                                            <v-select hide-details="" :items="sonkullanimYil" clearable v-model="GeciciCari.KKYil" :label="$t('Expiry-Year')" item-text="text" item-value="id"></v-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </div>
                                                <v-layout v-show="bankaposshow">
                                                    <v-flex xs12 sm6 md6>
                                                        <v-autocomplete :items="bankapositems" hide-details="" v-model="GeciciCari.PosKod" @change="taksitgetir(GeciciCari.PosKod)" item-text="Title" item-value="PosKodu" clearable :label="$t('Pos-Code')">
                                                        </v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-select :items="taksitsayi" hide-details="" v-model="GeciciCari.TaksitKod" item-text="TaksitAciklama" item-value="TaksitID" clearable :label="$t('Instalment')"></v-select>
                                                    </v-flex>
                                                </v-layout>
    
                                                <v-layout v-show="servisposshow">
                                                    <v-flex xs12 sm6 md6>
    
                                                        <v-autocomplete :items="bankapositems" hide-details="" @change="taksitgetirservis(GeciciCari.ServisPosKod)" v-model="GeciciCari.ServisPosKod" item-text="Title" item-value="PosKodu" clearable :label="$t('Service-POS-Code')">
                                                        </v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md6>
    
                                                        <v-select :items="taksitsayiservis" hide-details="" v-model="GeciciCari.ServisTaksitKod" item-text="TaksitAciklama" item-value="TaksitID" clearable :label="$t('Instalment')"></v-select>
                                                    </v-flex>
                                                </v-layout>
    
                                                <v-flex xs12 sm12 md12>
    
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Service-Amount')" v-model="GeciciCari.ServisTutar" :autocomplete="'autocomplete'">
                                                    </parainput>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
    
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Other-Service-Amount')" v-model="GeciciCari.DigerServisTutar" :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Discount-Amount')" v-model="GeciciCari.IskontoTutar" :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>
                                                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="RezTutarEtiket" v-model="GeciciCari.ReserveTutar" :autocomplete="'autocomplete'">
                                                </parainput>
    
                                                <v-flex xs12 sm12 md12>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'HY Tutar'" v-model="GeciciCari.HYTutar" :autocomplete="'autocomplete'">
                                                    </parainput>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <v-select hide-details="" v-model="GeciciCari.DovizTipi" :items="doviztipi" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <bolumcomp v-model="GeciciCari.BolumKodu" :etiket="$t('Department-Code-Bolum')">
                                                    </bolumcomp>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field v-model="GeciciCari.GSM" label="GSM" hide-details="">
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <tarihim :v-bind="GeciciCari.DateofRes" v-model="GeciciCari.DateofRes" :etiket="this.$t('Date')">
                                                    </tarihim>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
    
                                                    <analizcomp :hd="true" v-model="GeciciCari.AnalizKodu" :etiket="$t('Analysis') + ' 1'">
                                                    </analizcomp>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Analysis-Amount') + '1'" v-model="GeciciCari.AnalizTutar" :autocomplete="'autocomplete'">
                                                    </parainput>
                                                </v-flex>
    
                                                <v-flex xs12 sm6 md6>
                                                    <analizcomp :hd="true" v-model="GeciciCari.AnalizKodu1" :etiket="$t('Analysis')+' 2'">
                                                    </analizcomp>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :detaygizle="true" :etiket="$t('Analysis-Amount') + '2'" v-model="GeciciCari.AnalizTutar1" :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field v-model="GeciciCari.SiparisID" :label="$t('Order-ID')" hide-details="">
                                                    </v-text-field>
                                                </v-flex>
    
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field  v-model="GeciciCari.MakbuzNo" hide-details="" :label="$t('Receipt-No')"></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field :label="$t('Slip-No')"  v-model="GeciciCari.Slipkod" hide-details=""></v-text-field>
                                                </v-flex>
    
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field v-model="GeciciCari.Aciklamalar.Aciklama1" :label="$t('Description')" hide-details="">
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field v-model="GeciciCari.Aciklamalar.Aciklama2" :label="$t('Description')" hide-details="">
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field v-model="GeciciCari.Aciklamalar.Aciklama3" :label="$t('Description') + '3'" hide-details="">
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field v-model="GeciciCari.Aciklamalar.Aciklama4" :label="$t('Description') + '4'" hide-details="">
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field v-model="GeciciCari.Aciklamalar.Aciklama5" :label="$t('Description')+'5'" hide-details="">
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field v-model="GeciciCari.Aciklamalar.Aciklama6" :label="$t('Description') + '6'" hide-details="">
                                                    </v-text-field>
                                                </v-flex>
    
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field v-model="GeciciCari.Aciklamalar.Aciklama7" :label="$t('Description')+'7'" hide-details="">
                                                    </v-text-field>
                                                </v-flex>
    
    
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>
    
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click.native="gecicicaridialog=false">{{$t("cancel_button")}}</v-btn>
                            <v-btn color="blue darken-1" flat @click="gecicicarisor()"> {{ $t('Change-Temporary-Current-Code') }} </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
    
                  <v-dialog v-model="multipleTicket" v-if="multipleTicket" persistent="" scrollable="" max-width="500px">
                    <v-card color="grey lighten-5">
                        <v-card-title> Bilet Seçimi </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-flex pa-2 xs12 sm12 md12>
                            <v-data-table :headers="headersMultiple" :rows-per-page-items=[50,100] :items="multipleTicketItems">
                                <template slot="items" slot-scope="props">
                                <tr @click="gitliste(props.item.status,props.item.havayoluKodu,props.item.biletNo,props.item.ucusTipi)" item>
                                  <td class="text-xs-left">{{ props.biletNo }}</td>
                                  <td class="text-xs-left">{{ props.havayoluKodu }}</td>
                                  <td class="text-xs-left">{{ props.ucusTipi }}</td>
                                </tr>
                                </template>
                              </v-data-table>
                            </v-flex>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click.native="multipleTicket=false">{{$t("cancel_button")}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
    
            </v-layout>
        </v-card>
    
        <v-layout row="" wrap v-if="listegorunum">
    
            <v-flex xs12 sm12 md12>
                <v-card flat="" color="grey lighten-5">
                    <v-flex xs12 sm12 md12>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md9>
                                <v-layout align-center="" fill-height="">
                                    <div class=" font-weight-large grey--text title ">
                                        &nbsp; {{recordcount}} <span v-if="secilenkayitlar.length>0" class=" font-weight-large red--text title ">
                                            {{secilenkayitlar.length}} {{ $t('Records-are-selected') }} </span>
                                    </div>
                                </v-layout>
                            </v-flex>
                            <v-flex v-show="kayitvarmi" xs12 sm12 md2>
                                <v-select hide-details="" :items="siralamatipiitems" color="grey darken-1" v-model="siralamatipi" item-text="text" item-value="value" :label="$t('Sort-By')">
                                </v-select>
                            </v-flex>
                            <v-flex v-show="kayitvarmi" xs12 sm12 md1>
                                <v-select hide-details="" :items="kayitsayisi" color="grey darken-1" v-model="kayitadet" item-text="text" item-value="value" :label="$t('Show')"></v-select>
                            </v-flex>
                        </v-layout>
    
                        <v-layout row wrap>
    
                            <v-flex xs12 sm4 md4>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-layout v-if="kayitvarmi" justify-center="" align-center>
                                            <v-checkbox v-model="tumunuseckaldir" :label="$t('Choose-All')"></v-checkbox>
    
                                        </v-layout>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-flex>
    
                            <v-flex xs12 sm8 md8>
                                <v-layout fill row wrap justify-end="">
    
                                    <v-btn color="info" v-if="(gecicicaridegistirBtn || caridegistirBtn || voidyapBtn || iadeekleBtn || alisfaturanoBtn ||  sirketDegistirBtn || sirketeKopyalaBtn) && kayitvarmi" @click="filtreiptal()">
                                        {{ $t('Cancel-Process') }}
                                    </v-btn>
    
                                    <v-btn color="info" v-if="caridegistirBtn && kayitvarmi" @click="carikontrol()">
                                        <v-icon>playlist_add_check</v-icon> {{ $t('Change-Current-Details-Selected-Cards') }}
                                    </v-btn>
    
                                    <v-btn color="info" @click="gecicicarikontrol()" v-if="gecicicaridegistirBtn && kayitvarmi">
                                        <v-icon>playlist_add_check</v-icon> {{ $t('Change-Temporary-Current-Details-Selected-Cards') }}
                                    </v-btn>
    
                                     <v-btn color="info" @click="sirketDegistir()" v-if="sirketDegistirBtn && kayitvarmi">
                                        <v-icon>playlist_add_check</v-icon>Seçili Kayıtların Şirketlerini Değiştir
                                    </v-btn>

                                      <v-btn color="info" @click="sirketeKopyala()" v-if="sirketeKopyalaBtn && kayitvarmi">
                                        <v-icon>playlist_add_check</v-icon>Seçili Kayıtları Şirkete Kopyala
                                     </v-btn>
    
                                    <v-btn color="info" @click="voidkontrol()" v-if="voidyapBtn && kayitvarmi">
                                        <v-icon>playlist_add_check</v-icon> {{ $t('Void-Selected-Cards') }}
                                    </v-btn>
    
                                    <v-btn color="info" @click="iadekontrol()" v-if="iadeekleBtn && kayitvarmi">
                                        <v-icon>playlist_add_check</v-icon> {{ $t('Process-Return-Invoice-Selected-Cards') }}
                                    </v-btn>
    
                                    <v-btn color="info" @click="alisFaturaNokontrol()" v-if="alisfaturanoBtn && kayitvarmi">
                                        <v-icon>playlist_add_check</v-icon> {{ $t('Process-Purchase-Invoice-Selected-Cards') }}
                                    </v-btn>
    
                                </v-layout>
                            </v-flex>
                        </v-layout>
    
                    </v-flex>
    
                    <v-flex pa-2 v-for="item in filtreticket" v-bind:key="item.id" xs12 sm12 md12>
                        <v-hover>
                            <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" width="100%">
                                <v-list two-line="">
                                    <v-layout row wrap>
                                        <v-flex xs12 sm12 md12>
                                            <v-card flat class="black--text">
                                                <v-card flat="">
                                                    <v-card-actions>
                                                        <v-layout row wrap>
                                                            <v-list-tile>
                                                                <v-list-tile-content>
                                                                    <v-layout justify-center="" align-center>
                                                                        <v-checkbox hide-details="" v-model="secilenkayitlar" :value="item">
                                                                        </v-checkbox>
    
                                                                    </v-layout>
                                                                </v-list-tile-content>
                                                            </v-list-tile>
    
                                                            <v-flex sm12 md1>
                                                                <v-card flat="">
                                                                    <v-list-tile>
                                                                        <v-list-tile-content>
                                                                            <v-img :src="getImgUrl(item.GenelBilgileri.HavaYoluKodu)" height="60%" width="60%" contain>
                                                                            </v-img>
                                                                            <v-img v-if="item.GenelBilgileri.Acente =='A'" :src="getImgUrl(item.GenelBilgileri.HavaYoluKodu)" alt="K" height="21px" width="86px" contain>
                                                                            </v-img>
    
                                                                        </v-list-tile-content>
                                                                    </v-list-tile>
                                                                </v-card>
                                                            </v-flex>
                                                              <v-tooltip bottom>
                                                                  <template v-slot:activator="{ on }"> 
                                                            <v-flex xs12 sm4 md2 v-on="on">
                                                                <v-layout align-start justify-start row fill-height>
                                                                    <v-card flat="">
                                                                        <v-list-tile>
                                                                            <v-list-tile-content>
                                                                                    
                                                                                <v-layout row align-center justify-start>
                                                                                  
                                                                                    <v-chip v-if="item.GenelBilgileri.Status=='S' " small="" color="green" text-color="white">
                                                                                        {{$t('Sales')}}</v-chip>
                                                                                    <v-chip v-if="item.GenelBilgileri.Status=='Ia' " small="" color="red" text-color="white">
                                                                                        {{$t('Refund')}}</v-chip>
                                                                                    <v-chip v-if="item.GenelBilgileri.Status=='V' " small="" color="yellow" text-color="white">
                                                                                        {{$t('Void')}}</v-chip>
                                                                                   
                                                                                    <v-list-tile-title>
                                                                               
                                                                                        <span class='grey-text--primary font-weight-medium caption '>
                                                                                            {{item.GenelBilgileri.HavaYoluKodu}}
                                                                                            -
                                                                                            {{item.GenelBilgileri.BiletNo}}
                                                                                            <template v-if="item.GenelBilgileri.PnrNo">
                                                                                            (PNR: {{item.GenelBilgileri.PnrNo}})
                                                                                            </template>
                                                                                            -
                                                                                            {{item.GenelBilgileri.UcusTipi}}
                                                                                        </span>
                                                                               
                                                                                    </v-list-tile-title>
                                                                                    
                                                                                </v-layout>
                                                                              
                                                                                <v-list-tile-sub-title>
                                                                                    &nbsp; <span class='grey-text--primary caption font-weight-medium'>
                                                                                        {{item.GenelBilgileri.YolcuAdi}}</span>
                                                                                </v-list-tile-sub-title>
                                                                                <v-list-tile-sub-title>
                                                                                    &nbsp; <span class='grey-text--primary caption font-weight-medium'>
                                                                                        {{item.GenelBilgileri.MusteriKodu.Kod}}
                                                                                        -{{item.GenelBilgileri.MusteriKodu.Unvan}}
                                                                                    </span>
                                                                                </v-list-tile-sub-title>
                                                                            </v-list-tile-content>
                                                                        </v-list-tile>
                                                                    </v-card>
                                                                </v-layout>
                                                            </v-flex>
                                                                </template>
                                                                 <span> {{ $t("Booker") }} : {{ item.GenelBilgileri.RezervasyonAlan }} </span> <br/>
                                                                 <span> {{ $t("Person-Offering-Booking") }} : {{ item.GenelBilgileri.RezervasyonVeren }} </span>
                                                             </v-tooltip> 
    
                                                            <v-flex xs12 sm4 md2>
                                                                <v-layout align-start justify-start row fill-height>
                                                                    <v-card flat="">
                                                                        <v-list-tile>
                                                                            <v-list-tile-content>
                                                                                <v-layout row wrap align-center="" justify-start>
                                                                                    <v-list-tile-title>
                                                                                        <div class="font-weight-large red--text title ">
                                                                                            {{item.TarihBilgileri.SatisTarihi}}
                                                                                        </div>
                                                                                    </v-list-tile-title>
                                                                                    <v-list-tile-sub-title v-if="item.GenelBilgileri.Status=='Ia'">
                                                                                        <div class="font-weight-large grey--text caption">
                                                                                            {{$t('Refund-Date')}}:
                                                                                            <span class="font-weight-large red--text caption">
    
                                                                                                {{item.TarihBilgileri.IadeTarihi}}
                                                                                            </span>
                                                                                        </div>
                                                                                    </v-list-tile-sub-title>
                                                                                    <v-list-tile-sub-title v-if="item.GenelBilgileri.Status=='V'">
                                                                                        <div class="font-weight-large grey--text caption ">
                                                                                            {{ $t('Void-Date') }} :<span class="font-weight-large red--text caption">
                                                                                                {{item.TarihBilgileri.IptalTarihi}}
                                                                                            </span>
                                                                                        </div>
                                                                                    </v-list-tile-sub-title>
                                                                                </v-layout>
                                                                            </v-list-tile-content>
                                                                        </v-list-tile>
                                                                    </v-card>
                                                                </v-layout>
                                                            </v-flex>
    
                                                            <v-flex class="hidden-md-and-up" xs2 sm2 md2>
                                                            </v-flex>
    
                                                            <v-flex xs12 sm4 md2>
                                                                <v-layout align-start="" fill-height="" row wrap>
                                                                    <v-flex xs12 sm12 md12>
                                                                        <v-layout align-start="" row justify-start fill-height>
                                                                            <v-card flat="">
                                                                                <v-list-tile>
                                                                                    <v-list-tile-content style="'overflow=inherit';">
                                                                                        <v-list-tile-sub-title>
                                                                                            <div class="font-weight-medium caption ">
                                                                                                {{ $t('Invoice-Date') }} :
                                                                                                {{item.FaturaBilgileri.FaturaTarihi || '-'}}
                                                                                            </div>
                                                                                        </v-list-tile-sub-title>
    
                                                                                        <v-list-tile-sub-title>
                                                                                            <div class="font-weight-medium caption ">
                                                                                                {{$t('Invoice-No')}}:
                                                                                                {{item.FaturaBilgileri.FaturaNo || '-'}}
                                                                                            </div>
                                                                                        </v-list-tile-sub-title>
                                                                                        <v-list-tile-sub-title>
                                                                                            <div v-if="item.FaturaBilgileri.FaturaDurumu=='Fatura Beklemede'" class="font-weight-medium caption ">
                                                                                                <v-icon hide-details color="yellow" small="">
                                                                                                    access_alarm
                                                                                                </v-icon>
                                                                                                {{$t(item.FaturaBilgileri.FaturaDurumu)}}
                                                                                            </div>
    
                                                                                            <div v-if="item.FaturaBilgileri.FaturaDurumu=='Alıcı Onayladı'" class="font-weight-medium caption ">
                                                                                                <v-icon hide-details color="green" small="">
                                                                                                    check_box
                                                                                                </v-icon>
                                                                                                {{$t(item.FaturaBilgileri.FaturaDurumu)}}
                                                                                            </div>
    
                                                                                            <div v-if="item.FaturaBilgileri.FaturaDurumu=='Fatura Gönderildi'" class="font-weight-medium caption ">
                                                                                                <v-icon hide-details color="red" small="">
                                                                                                    send
                                                                                                </v-icon>
                                                                                                {{$t(item.FaturaBilgileri.FaturaDurumu)}}
                                                                                            </div>
    
                                                                                        </v-list-tile-sub-title>
    
                                                                                    </v-list-tile-content>
                                                                                </v-list-tile>
                                                                            </v-card>
                                                                        </v-layout>
                                                                    </v-flex>
    
                                                                </v-layout>
                                                            </v-flex>
    
                                                            <v-flex xs12 sm4 md2>
                                                                <v-layout>
    
                                                                    <v-flex xs12 sm6 md6>
                                                                        <v-layout align-start="" justify-start fill-height>
                                                                            <v-card flat="">
                                                                                <v-list-tile>
                                                                                    <v-list-tile-content>
                                                                                        <v-list-tile-sub-title>
                                                                                            <div class="font-weight-medium caption ">
                                                                                                {{$t('Ticket-Amount')}} :
                                                                                            </div>
                                                                                        </v-list-tile-sub-title>
                                                                                        <v-list-tile-sub-title>
                                                                                            <div class="font-weight-medium caption ">
                                                                                                {{$t('Taxes')}}:
                                                                                            </div>
                                                                                        </v-list-tile-sub-title>
                                                                                        <v-list-tile-sub-title>
                                                                                            <div class="font-weight-medium caption ">
                                                                                                {{ $t('Service-Cost') }} :
                                                                                            </div>
                                                                                        </v-list-tile-sub-title>
                                                                                        <v-list-tile-sub-title>
                                                                                            <div v-if="ListInput.Filtreler.BiletTipi=='I'" class="font-weight-medium caption ">
                                                                                                {{ $t('Penalty-Amount-v2') }} :
                                                                                            </div>
                                                                                        </v-list-tile-sub-title>
    
                                                                                    </v-list-tile-content>
                                                                                </v-list-tile>
                                                                            </v-card>
                                                                        </v-layout>
                                                                    </v-flex>
    
                                                                    <v-flex xs12 sm6 md6>
                                                                        <v-layout row justify-end="" fill-height>
                                                                            <v-card flat="">
                                                                                <v-list-tile>
                                                                                    <v-list-tile-content>
                                                                                        <v-list-tile-sub-title>
                                                                                            <v-layout align-center="" justify-end>
                                                                                                <div class="font-weight-medium caption ">
                                                                                                    {{item.TutarBilgileri.Tutar.Tutar}} 
                                                                                                    {{getparabirimi()}}
                                                                                                </div>
                                                                                            </v-layout>
                                                                                        </v-list-tile-sub-title>
                                                                                        <v-list-tile-sub-title>
                                                                                            <v-layout align-center="" justify-end="">
                                                                                                <div class="font-weight-medium caption ">
                                                                                                    {{item.TutarBilgileri.Vergiler}}
                                                                                                    {{getparabirimi()}}
                                                                                                </div>
                                                                                            </v-layout>
                                                                                        </v-list-tile-sub-title>
                                                                                        <v-list-tile-sub-title>
                                                                                            <v-layout align-center="" justify-end="">
                                                                                                <div class="font-weight-medium caption ">
                                                                                                    {{item.TutarBilgileri.ServisBedeli}}
                                                                                                    {{getparabirimi()}}
                                                                                                </div>
                                                                                            </v-layout>
                                                                                        </v-list-tile-sub-title>
                                                                                        <v-list-tile-sub-title>
                                                                                            <v-layout align-center="" justify-end>
                                                                                                <div v-if="ListInput.Filtreler.BiletTipi=='I'" class="font-weight-medium caption ">
                                                                                                    {{item.TutarBilgileri.CezaTutar.CezaTutar | moneyformat}}{{getparabirimi()}}
                                                                                                </div>
                                                                                            </v-layout>
                                                                                        </v-list-tile-sub-title>
                                                                                    </v-list-tile-content>
                                                                                </v-list-tile>
                                                                            </v-card>
                                                                        </v-layout>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-flex>
    
                                                            <v-flex xs12 sm4 md1>
                                                                <v-layout row align-center justify-center="" fill-height="">
                                                                    <v-card flat="">
                                                                        <v-list-tile>
                                                                            <v-list-tile-content>
                                                                                <v-layout row wrap justify-center="">
                                                                                    <v-list-tile-title>
                                                                                        <v-layout row wrap justify-center="">
                                                                                            {{$t('Net-Amount')}}
                                                                                        </v-layout>
                                                                                    </v-list-tile-title>
                                                                                    <v-list-tile-sub-title>
                                                                                        <v-layout row wrap justify-end="">
                                                                                            <div class="red--text subheading">
                                                                                                {{item.TutarBilgileri.NetTutar.NetTutar }}
                                                                                                {{getparabirimi()}}
                                                                                            </div>
                                                                                           
                                                                                        </v-layout>
                                                                                        <!-- <v-layout v-if="item.TutarBilgileri.DovizliTutar.DovizliTutar>0"  row wrap justify-center="">
                                                                                            <div class="font-weight red--text caption ">
                                                                                                {{item.TutarBilgileri.DovizliTutar.DovizliTutar }}
                                                                                                {{item.TutarBilgileri.Doviz}}
                                                                                            </div>
                                                                                        </v-layout> -->
                                                                                    </v-list-tile-sub-title>
                                                                                    <v-list-tile-title>
                                                                                        <v-layout row wrap justify-center="">
                                                                                            <div class="font-weight green--text caption ">
                                                                                                {{item.OdemeBilgileri.SatisSekli}}
                                                                                            </div>
                                                                                        </v-layout>
    
                                                                                    </v-list-tile-title>
                                                                                </v-layout>
                                                                            </v-list-tile-content>
    
                                                                        </v-list-tile>
                                                                    </v-card>
                                                                </v-layout>
                                                            </v-flex>
    
                                                            <v-flex sm4 md1>
                                                                <v-layout row align-center justify-end="">
                                                                    <v-card flat="">
                                                                        <v-list-tile>
                                                                            <v-list-tile-action>
                                                                                <v-layout align-center="" fill-height="" justify-end>
                                                                                    <v-flex sm6 md6>
                                                                                        <v-btn icon @click="goBiletDetail(item)">
    <v-icon x-large color="grey">
        search
    </v-icon>
</v-btn>
                                                                                        <a v-if="item.GenelBilgileri.Status=='V'" target="_blank" v-bind:href="'#/bilet/yeni/id?' + 'isl=voidget&hyolukod=' + item.GenelBilgileri.HavaYoluKodu + '&biletno=' + item.GenelBilgileri.BiletNo + '&ucustipi=' + item.GenelBilgileri.UcusTipi">
                                                                                            <v-btn icon>
                                                                                                <v-icon x-large="" color="grey">
                                                                                                    search
                                                                                                </v-icon>
                                                                                            </v-btn>
                                                                                        </a>
                                                                                    </v-flex>
                                                                                </v-layout>
                                                                            </v-list-tile-action>
                                                                        </v-list-tile>
                                                                    </v-card>
                                                                </v-layout>
                                                            </v-flex>
    
                                                        </v-layout>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-card>
                                        </v-flex>
                                    </v-layout>
    
                                </v-list>
                            </v-card>
                        </v-hover>
                    </v-flex>
    
                </v-card>
            </v-flex>
        </v-layout>
    
        <v-dialog v-model="caridialog" v-if="caridialog" width="500">
            <v-card>
                <v-flex xs12 sm12>
                    <v-toolbar size="120px" dark color="info">
                        <v-toolbar-title class="baslikfont">{{$t('Attention')}} !</v-toolbar-title>
                    </v-toolbar>
                </v-flex>
    
                <v-card-text>
    
                    <v-form ref="formcari" v-model="valid" lazy-validation>
                        <v-flex mb-1 v-if="dialogtype=='cari'" xs12 sm12 md12>
                            <cariaracomp v-bind:etiket="$t('Select-Current-Account')" v-bind:value="yenicari" :loading="loading" v-bind:zorunlumu="true" v-model="yenicari" :Coper="false">
                            </cariaracomp>
    
                        </v-flex>
                    </v-form>
    
                    <v-form ref="formSirketDegistir" v-model="valid" lazy-validation>
                        <v-flex mb-1 v-if="dialogtype=='sirketDegistir'" xs12 sm12 md12>
                            <v-select
                                :items="altsirketler"
                                v-model="changeCompany"
                                item-text="SirketAdi"
                                item-value="SirketKodu"
                                label="Şirket Seçiniz"
                            ></v-select>
                  
                        </v-flex>
                    </v-form>
                     <v-form ref="formSirketeKopyala" v-model="valid" lazy-validation>
                      <v-flex mb-1 v-if="dialogtype=='sirketeKopyala'" xs12 sm12 md12>
                        <v-select
                           :items="altsirketler"
                            v-model="changeCompany"
                            item-text="SirketAdi"
                            item-value="SirketKodu"
                            label="Şirket Seçiniz"
                        ></v-select>

                     <v-checkbox
                      v-model="servisUcretiTasinmasin"
                      label="Servis Ücreti Taşıma"
                      hide-details
                    ></v-checkbox>

                     <v-checkbox
                      v-model="rezervAlanTasinmasin"
                      label="Rezerv Alan Taşıma"
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                 </v-form>
                    <v-form ref="formvoid" v-model="valid" lazy-validation>
                        <v-flex v-if="dialogtype=='void'" xs12 sm6 md6>
                            <tarihim :etiket="$t('Void-Date')" :detaygizle="false" v-model="voiddate" v-bind:defaultvalue="'ok'" :rules="[v => !!v || $t('Please-select-a-date')]">
                            </tarihim>
                        </v-flex>
                    </v-form>
    
                    <v-form ref="formiade" v-model="valid" lazy-validation>
                        <v-flex v-if="dialogtype=='iade'" xs12 sm6 md6>
                            <tarihim :etiket="$t('Refund-Invoice-Date')" :detaygizle="false" v-model="iadefattarih" v-bind:defaultvalue="'ok'" :rules="[v => !!v || $t('Mandatory-section')]">
                            </tarihim>
                        </v-flex>
                        <v-layout row wrap>
                            <v-flex v-if="dialogtype=='iade'" xs12 sm6 md6>
                                <v-text-field :label="$t('Returns-Invoice-No')" maxlength="10" :rules="[v => !!v || $t('Mandatory-section')]" v-model="faturaBelgeNo"></v-text-field>
                            </v-flex>
                            <v-flex v-if="dialogtype=='iade'" xs12 sm6 md6>
                                <v-text-field :label="$t('Return-Document-No')" :rules="[v => !!v || $t('Mandatory-section')]" v-model="faturaIadeBelgeNo"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-form>
    
                    <v-form ref="formalisfatura" v-model="valid" lazy-validation>
                        <v-flex v-if="dialogtype=='alisfatura'" xs12 sm6 md6>
                            <tarihim :etiket="$t('Buying-Invoice-Date')" :detaygizle="false" v-model="iadefattarih" v-bind:defaultvalue="'ok'" :rules="[v => !!v || $t('Mandatory-section')]">
                            </tarihim>
                        </v-flex>
                        <v-layout row wrap>
                            <v-flex v-if="dialogtype=='alisfatura'" xs12 sm6 md6>
                                <v-text-field :label="$t('Buying-Invoice-No')" :rules="[v => !!v || $t('Mandatory-section')]" v-model="faturaBelgeNo"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-form>
    
                    <v-flex pt-2 xs12 sm12 md12>
                        {{secilenkayitlar.length}} {{dialogmesaj}}
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
    
                    <v-btn color="primary" flat @click.native="caridialog=false">
                        {{$t("cancel_button")}}
                    </v-btn>
                    <v-btn v-if="dialogtype=='cari'" color="primary" flat @click="carikoddegistir()">
                        {{$t('Yes')}}
                    </v-btn>
                    <v-btn v-if="dialogtype=='alisfatura'" color="primary" flat @click="alisFaturaNoisle()">
                        {{$t('Yes')}}
                    </v-btn>
                    <v-btn v-if="dialogtype=='void'" color="primary" flat @click="topluvoidyap()">
                        {{$t('Yes')}}
                    </v-btn>
                    <v-btn v-if="dialogtype=='iade'" color="primary" flat @click="geleniadefaturisle()">
                        {{$t('Yes')}}
                    </v-btn>
                    <v-btn v-if="dialogtype=='sirketDegistir'" color="primary" flat @click="biletSirketDegistir()">
                        {{$t('Yes')}}
                    </v-btn>
                     <v-btn v-if="dialogtype=='sirketeKopyala'" color="primary" flat @click="biletSirketeKopyala()">
                        {{$t('Yes')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    
        <v-dialog v-model="gecicicaridialogsor" v-if="gecicicaridialogsor" width="500">
            <v-card>
                <v-flex xs12 sm12>
                    <v-toolbar size="120px" dark color="info">
                        <v-toolbar-title class="baslikfont">{{$t('Attention')}} !</v-toolbar-title>
                    </v-toolbar>
                </v-flex>
    
                <v-card-text>
                    {{secilenkayitlar.length}} {{dialogmesajgecici}}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click.native="gecicicaridialogsor=false">
                        {{$t("cancel_button")}}
                    </v-btn>
                    <v-btn color="primary" flat @click="gecicicarikoddegistir()">
                        {{$t('Yes')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="bulkPdfDialog" max-width="420">
    <v-card>
        <v-card-title class="headline">
            Toplu PDF İndir
        </v-card-title>

        <v-card-text>
            <div style="margin-bottom: 12px;">
                <strong>PDF'te tutar gösterilsin mi?</strong>
            </div>

            <v-radio-group v-model="bulkPdfShowAmount" row>
                <v-radio label="Tutarı Göster" :value="true"></v-radio>
                <v-radio label="Tutarı Gizle" :value="false"></v-radio>
            </v-radio-group>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn flat @click="bulkPdfDialog = false">
                Vazgeç
            </v-btn>

            <v-btn flat color="primary" @click="bulkPdfDialog = false; bulkDownloadPdf();">
                İndir
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>

<v-dialog
    v-model="bulkPdfLoading"
    persistent
    hide-overlay
    width="300"
>
    <v-card color="primary" dark>
        <v-card-text class="pa-4" style="display:flex; align-items:center; gap:12px;">
            <v-progress-circular
                indeterminate
                color="white"
                size="28"
            ></v-progress-circular>

            <span>PDF hazırlanıyor, lütfen bekleyiniz...</span>
        </v-card-text>
    </v-card>
</v-dialog>

    
        <template v-if="vmodelpagination">
            <div class="text-xs-center">
                <v-container>
                    <v-layout justify-center>
                        <v-flex xs8>
                            <v-pagination :disabled="paginationDisabled" color="info" v-model="sayfalama" :length="pagenumber"></v-pagination>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
        </template>
    
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
    
    </div>
    </template>
    
    <script>
    import auth from '../../../api/auth'
    import kredikartcomp from "@/components/app/bilet/partpage/kredikartcomp.vue"
    import logoo from '../../../assets/control'
    import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
    import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
    import analizcomp from "@/components/app/bilet/partpage/analizcomp.vue"
    import parainput from "@/components/app/customcomp/parainput.vue"
    import bolumcomp from "@/components/app/bilet/partpage/bolumcomp.vue"
    import tarihim from "@/components/app/customcomp/tarihim.vue"
    import helpers from "@/components/app/customcomp/helpers.js"
    import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
    import cariaracomp from '@/components/app/customcomp/cariaracomp'
    import loadingcomp from "@/components/app/customcomp/loadingcomp";
    import { i18n } from '@/plugins/i18n.js'
    export default {
        data() {
    
            return {
            servisUcretiTasinmasin: false,
            rezervAlanTasinmasin: false,
            bulkPdfLoading: false,
            bulkPdfShowAmount: true,
            bulkPdfDialog: false,
            simpleMode: false,
                searchNo:null,
                geciciCounter:0,
                sayfayetki: {
                    Screen: false,
                    Update: false,
                    Save: false,
                    Delete: false,
                    Status: false,
                    Message: null,
                    islem: 0,
                },
                servisclass: {
                    SirketKodu: '',
                    Cari: {
                        Kod: null
                    },
                    Parkurlar: {
                        Parkur1: '',
                        Parkur2: '',
                        Parkur3: '',
                        Parkur4: '',
                        Parkur5: '',
                    },
                    Hat: '',
                    DefaultKontrol: false
                },
                filtrevarmi: false,
                searchIcon: 'search',
               
                paginationDisabled: false,
    
                filtreUyarimesaj: false,
    
                caridegistirBtn: false,
                filtrecaridegistirView: false,
                cariOnay: false,
                bilettipisatisOnay: false,
                faturatipifaturalanmamislarOnay: false,
    
                filtregecicicaridegistirView: false,
                tekhattpiiOnay: false,
                gecicarilerOnay: null,
                gecicicaridegistirBtn: false,
    
                filtrevoidyapView: false,
                voidyapBtn: false,
    
                filtreiadekontrolView: false,
                bilettipiiadeOnay: false,
                dekontbasOnay: false,
                giderpusulaOnay: false,
                iadefaturagelmeyenOnay: false,
    
                dekontbasilanOnay: false,
                iadebelgedekontOnay: false,
                iadefaturasigelmeyenOnay: false,
                iadeekleBtn: false,
    
                filtrealisfaturaView: false,
                bilettipisatisiadeOnay: false,
                acentefatnoOnay: false,
                alisfaturanoBtn: false,
    
                iadefattarih: null,
                faturaBelgeNo: null,
                faturaIadeBelgeNo: null,
                bankaposshow: false,
                servisposshow: false,
                bankapositems: [],
                taksitsayi: [],
                taksitsayiservis: [],
                kredikartshow: false,
    
                sirketDegistirBtn: false,
                sirketeKopyalaBtn:false,
                sirketeKopyalaFiltre:false,
                sirketDegistirFiltre:false,
                changeCompany:0,
    
                karttipi: [{
                        id: 'M',
                        text: 'Master Card'
                    },
                    {
                        id: 'VI',
                        text: 'VISA'
                    },
                    {
                        id: 'A',
                        text: 'American Express'
                    },
                ],
                sonkullanimAy: [{
                        id: '01',
                        text: '1'
                    },
                    {
                        id: '02',
                        text: '2'
                    },
                    {
                        id: '03',
                        text: '3'
                    },
                    {
                        id: '04',
                        text: '4'
                    },
                    {
                        id: '05',
                        text: '5'
                    },
                    {
                        id: '06',
                        text: '6'
                    },
                    {
                        id: '07',
                        text: '7'
                    },
                    {
                        id: '08',
                        text: '8'
                    },
                    {
                        id: '09',
                        text: '9'
                    },
                    {
                        id: '10',
                        text: '10'
                    },
                    {
                        id: '11',
                        text: '11'
                    },
                    {
                        id: '12',
                        text: '12'
                    }
                ],
                sonkullanimYil: [
                    '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016',
                    '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028',
                    '2029', '2030'
                ],
                dialogmesajgecici: null,
                gecicicaridialogsor: false,
                geciciyenicari: null,
                doviztipi: [],
                filtreuyari: '',
                filtrealert: false,
                voiddate: null,
                statecarigecic: [],
                loadinggecici: false,
                yenicarigecici: null,
                yenicarigecicisearch: null,
                gecicicaridialog: false,
                nereden: 0,
                aramayapildi: false,
                kayitadet: 50,
                siralamatipi: 'SalesDate',
                kayitvarmi: false,
                caridialog: false,
                dialogmesaj: null,
                yedekListInput: null,
                tumunuseckaldir: false,
                statecariyeni: [],
                yenicari: null,
                yenicarisearch: null,
                dialogcarikoddegistir: false,
                secilenkayitlar: [],
                secilenkayitlaryedek: [],
                multipleTicketItems:[],
                multipleTicket:false,
                itemsparkur: [],
                itemsyon: [{
                    text: this.$t('Domestic'),
                    value: 'I'
                }, {
                    text: this.$t('International'),
                    value: 'D'
                }, {
                    text: 'BSP',
                    value: 'B'
                }],
       
               
                RezTutarEtiket: 'Reserve Tutar',
                itemsairlinelist: [],
                ListInputYedek: [],
                dialogtype: null,
    
                ListInput: {
                    SirketKodu: null,
                    BaslangicTarihi: null,
                    BitisTarihi: null,
                    Carikod: null,
                    HavaYoluKodu: null,
                    FormNo: null,
                    BiletNo: null,
                    TextSearch: null,
                    Paging: {
                        SayfaNo: null,
                        VeriAdet: 50,
                        SiralamaTip: 0
                    },
                    Filtreler: {
                        CariKod: null,
                        Havayollari: [],
                        Parkurlar: [],
                        HatTipi: [], // I : iç hat, D: Dış hat, B: Bsp
                        BiletTipi: 'S', // S: Satış, I: Iade, V : Void
                        Ucus1: null,
                        Ucus2: null,
                        KesenKisi: null,
                        MasrafMerkezi: null,
                        PosKod: null,
                        DekontBas: false,
                        KrediKartNo: null,
                        GiderPusulasi: 0, // 0: seçim yok, 1 : basılmış, 2 : basılmamış
                        AcentaFatNo: 0, // 0 : seçim yok, 1 : fatura olan, 2 : fatura olmayan
                        IadeFatura: false,
                        SifirTutarGosterme:false,
                        RezVerenBosGoster:false,
                        GeciciCari: 0, // 0 : hepsi, 1 : geci haric, 2 : sadece gecici
                        FaturaStatus: 0, // 0 : hepsi, 1 : faturalanmamışlar, 2 : faturalanmışlar
                        BaslangicTutar: 0,
                        BitisTutar: 0,
                        YolcuAdi:null,
                        PnrNo:null,
                        TutarTip: 0, // 0 : NetTutar, 1 : Bilet Tutar, 2 : Servis Tutar, 3 : Iskonto Tutar
                        BiletAcenteTipi:0, // 0: hepsi  1: Acente  2: Direkt kesilenler
                    }
                },
                GeciciCari: {
                    KesenKisi: null,
                    Referans: null,
                    Masraf: null,
                    RezervasyonVeren: null,
                    RezervasyonAlan: null,
                    SatisSekli: 'K',
                    KrediKartNo: null,
                    KKCins: null,
                    KKAy: null,
                    KKYil: null,
                    ServisTutar: 0,
                    DigerServisTutar: 0,
                    IskontoTutar: 0,
                    HYTutar: 0,
                    PosKod: null,
                    TaksitKod: null,
                    ReserveTutar: 0,
                    ServisPosKod: null,
                    ServisTaksitKod: null,
                    DovizTip: null,
                    BolumKodu: null,
                    GSM: null,
                    DateofRes: null, //date
                    AnalizKodu: null,
                    AnalizTutar: 0,
                    AnalizKodu1: null,
                    AnalizTutar1: 0,
                    SiparisID: null,
                    MakbuzNo:null,
                    SlipKod:null,
                    Aciklamalar: {
                        Aciklama1: null,
                        Aciklama2: null,
                        Aciklama3: null,
                        Aciklama4: null,
                        Aciklama5: null,
                        Aciklama6: null,
                        Aciklama7: null,
                    }
    
                },
                Havayolu: {
                    HavaYoluKodu: null,
                    FormNo: null,
                    HavaYoluAdi: null
                    //devam eden class
                },
                searchliste: null,
                listegorunum: true,
                gorunumtipi: 'list',
                tablegorunum: false,
                kayitsayisivmodel: 50,
                kayitsayisi: [{
                    text: '50',
                    value: 50
                }, {
                    text: '100',
                    value: 100
                }],
                vmodelpagination: false,
                siralamavmodel: 0,
                recordcount: '',
                filtreticket: [],
                indexsayisi: 10,
                pagenumber: 1,
                sayfalama: 1,
                search1: '',
                value: null,
                caridegeri: null,
                dialogfiltre: false,
                loading: false,
                statecari: [],
                searchcari: '',
                renk1: 'info',
                date: null,
                menu: false,
                modal: false,
                dateFormatted: '',
                date2: null,
                menu2: false,
                dateFormatted2: '',
                modal2: false,
                harekettipi: '',
                items: [],
                itemsticket: [],
                StartDate: null,
                EndDate: null,
                load: false,
                load1: true,
                dialogmessage: '',
                dialog: false,
                progress: false,
                valid: true,
                snackbar: false,
                y: 'top',
                x: 'right',
                loadingmesaj: "",
                loadingdialog: false,
                mode: '',
                timeout: 6000,
                text1: '',
                tooltip: false,
                el: null,
                altsirketler:[]
    
                //  tooltiptutar: false,
                // eltutar: null,
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.prevRoute = from.path
            })
        },
        computed:{
        headersMultiple(){
            return [
            {
                text: this.$t('Ticket-No'),
                value: 'GenelBilgileri.BiletNo',
            },
            {
                text: 'HY Kodu',
                value: 'GenelBilgileri.HavaYoluKodu'
            },
            {
                text: this.$t('Type'),
                value: 'GenelBilgileri.UcusTipi'
            }
        ]
        },
        headers(){
            return [{
                text: 'HY Kodu',
                value: 'GenelBilgileri.HavaYoluKodu'
            },
            {
                text: this.$t('Ticket-No'),
                value: 'GenelBilgileri.BiletNo',
            },
            {
                text: this.$t('Type'),
                value: 'GenelBilgileri.UcusTipi'
            },
            {
                text: this.$t('Status'),
                value: 'GenelBilgileri.Status'
            },
            {
                text: this.$t('Client-Code'),
                value: 'GenelBilgileri.MusteriKodu.Kod'
            },
            {
                text: this.$t('Recorded-Invoice'),
                value: 'GenelBilgileri.MusteriKodu.EFaturaKayitliList'
            },
            {
                text: this.$t('Invoice-Type-v2'),
                value: 'GenelBilgileri.MusteriKodu.FaturaTip'
            },
            {
                text: this.$t('Invoice-Serial'),
                value: 'FaturaBilgileri.FaturaSeri'
            },
            {
                text: this.$t('Invoice-No'),
                value: 'FaturaBilgileri.FaturaNo'
            },
            {
                text: this.$t('Sales-Type-v2'),
                value: 'OdemeBilgileri.KrediKartBilgi.KrediKartTip'
            },
            {
                text: this.$t('Sales-Date'),
                value: 'TarihBilgileri.SatisTarihi'
            },
            {
                text: this.$t('Invoice-Date'),
                value: 'FaturaBilgileri.FaturaTarihi'
            },
            {
                text: this.$t('Net-Amount'),
                value: 'TutarBilgileri.NetTutar.NetTutar'
            },
            {
                text: this.$t('Sales-Amount-v2'),
                value: 'TutarBilgileri.Tutar.Tutar'
            },
            {
                text: this.$t('Return-Void-Date'),
                value: 'TarihBilgileri.IadeTarihi'
            },
            {
                text: this.$t('Return-Amount-v2'),
                value: 'Id'
            },
            {
                text:  this.$t('Penalty'),
                value: 'TutarBilgileri.CezaTutar.CezaTutar'
            },
            {
                text: this.$t('EX-Ticket-No'),
                value: 'GenelBilgileri.ExBiletNo'
            },
            {
                text: this.$t('Agency'),
                value: 'GenelBilgileri.Acente'
            },
            {
                text: 'KK Tip',
                value: 'OdemeBilgileri.KrediKartBilgi.KrediKartTip'
            },
            {
                text: this.$t('Service'),
                value: 'TutarBilgileri.ServisTutar.ServisTutar'
            }
        ]
        },
        satissekliitem(){
        return [{
            text: 'K-' + this.$t('With-Credit'),
            value: 'K'
        }, {
            text: 'P-' + this.$t('Cash'),
            value: 'P'
        }, {
            text: this.$t('R-Card'),
            value: 'R'
        }, {
            text: this.$t('C-Card'),
            value: 'C'
        }, {
            text: this.$t('F-Card'),
            value: 'F'
        }]
        },
    
        siralamatipiitems(){
            return [{
                text: this.$t('Date-Ascending'),
                value: 'SalesDate'
            }, {
                text: this.$t('Date-Descending'),
                value: 'SalesDateDesc'
            }, {
                text: this.$t('Ticket-No-Increasing'),
                value: 'TicketNumber'
            }, {
                text: this.$t('Ticket-No-Decreasing'),
                value: 'TicketNumberDesc'
            }, {
                text: this.$t('Invoice-Date-Ascending'),
                value: 'InvoiceDate'
            }, {
                text: this.$t('Invoice-Date-Descending'),
                value: 'InvoiceDateDesc'
            }, {
                text: this.$t('Current-Code-Increasing'),
                value: 'CustomerCode'
            }, {
                text: this.$t('Current-Code-Decreasing'),
                value: 'CustomerCodeDesc'
            }, {
                text: this.$t('Price-Ascending'),
                value: 'Price'
            }, {
                text: this.$t('Price-Descending'),
                value: 'PriceDesc'
            }]
            },
         aramatipi(){
         return [{
                value: '-',
                text: this.$t('Ticket-Number')
            },
            {
                value: '-',
                text: this.$t('Name-of-Passenger')
            },
            {
                value: '-',
                text: 'Pnr No'
            },
            {
                value: '-',
                text: this.$t('Currentcode_label')
            },
            {
                value: '-',
                text: this.$t('Current-Title')
            },
            {
                value: '-',
                text: this.$t('Ticket-Agent')
            },
            {
                value: '-',
                text: this.$t('Person-Receiving-Booking')
            },
            {
                value: '-',
                text: this.$t('Person-Offering-Booking')
            },
            {
                value: '-',
                text: this.$t('Flight-Number')
            },
            {
                value: '-',
                text: this.$t('Pessenger-Phone-Number')
            },
            {
                value: '-',
                text: this.$t('Email_label')
            }, {
                value: '-',
                text: this.$t('Taxnumber_label')
            }, {
                value: '-',
                text: this.$t('Identitynumber_label')
            }, {
                value: '-',
                text: this.$t('Ticket-Net-Amount')
            }
        ]
        },
    
            itemstipforCompanyChange() {
            return[{
                    text: this.$t('Sales'),
                    value: 'S'
                }, {
                    text: this.$t('Refund'),
                    value: 'I'
                }
            ]
            },
             itemstip(){
                 return [{
                    text: `${this.$t("Sales")}`,
                    value: 'S'
                }, {
                    text: this.$t('Refund'),
                    value: 'I'
                },
                {
                    text: this.$t('Void'),
                    value: 'V'
                }
            ]
             } 
        },
        methods: {
            bulkDownloadPdf: bulkDownloadPdf,
            imageUrlToBase64: imageUrlToBase64,
       
            simpleModeYukle() {
    var manageload = null;

    try {
        manageload = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
    } catch (e) {
        manageload = null;
    }

    if (manageload && manageload.UserInfo) {
        this.simpleMode =
            manageload.UserInfo.SimpleMode === true ||
            manageload.UserInfo.SimpleMode === 1 ||
            manageload.UserInfo.SimpleMode === "1" ||
            manageload.UserInfo.SimpleMode === "true";
    }
},
           goBiletDetail(item) {
    this.simpleModeYukle();

    var isl = item.GenelBilgileri.Status == 'V'
        ? 'voidget'
        : 'get';

    var baseUrl = this.simpleMode
        ? '#/bilet/newbilet2/id?'
        : '#/bilet/yeni/id?';

    var url = baseUrl
        + 'isl=' + encodeURIComponent(isl)
        + '&hyolukod=' + encodeURIComponent(item.GenelBilgileri.HavaYoluKodu)
        + '&biletno=' + encodeURIComponent(item.GenelBilgileri.BiletNo)
        + '&ucustipi=' + encodeURIComponent(item.GenelBilgileri.UcusTipi);

    window.open(url, '_blank');
},
            searchTicketNo(){
                this.loadingdialog = true
                this.ListInput.BiletNo = this.searchNo.trim();
                this.$http.post(auth.API_URL + 'api/Ticket/TicketList', this.ListInput, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    if (response.body.length == 1) {
                        this.loadingdialog = false;
                        
                        if (response.body[0].GenelBilgileri.Status == 'S' || response.body[0].GenelBilgileri.Status == 'Ia') {
                            let url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + response.body[0].GenelBilgileri.HavaYoluKodu + '&biletno=' + response.body[0]
                                .GenelBilgileri
                                .BiletNo + '&ucustipi=' + response.body[0].GenelBilgileri.UcusTipi
                            window.open(url, '_blank')
                        } else if (response.body[0].GenelBilgileri.Status == 'V') {
                            let url = '#/bilet/yeni/id?' + 'isl=voidget&hyolukod=' + response.body[0].GenelBilgileri.HavaYoluKodu + '&biletno=' + response.body[0]
                                .GenelBilgileri
                                .BiletNo + '&ucustipi=' + response.body[0].GenelBilgileri.UcusTipi
                            window.open(url, '_blank')
                        }
    
    
                    }else if(response.body.length > 1){
                        this.loadingdialog = false;
                        this.text1 = 'Birden fazla bilet bulundu. Listeleme yapılıyor.';
                        this.snackbar = true;
                        this.multipleTicket = true;
                        response.body.forEach(element => {
                            var item = {
                                biletNo:  element.GenelBilgileri.BiletNo,
                                havayoluKodu:  element.GenelBilgileri.HavaYoluKodu,
                                ucusTipi:  element.GenelBilgileri.UcusTipi,
                                status: element.GenelBilgileri.Status
                            };
                            this.multipleTicketItems.push(item);
                       
                        });
    
                      
                        this.BiletListele(1, this.siralamatipi, this.kayitadet, true);
    
                    } else {
                        this.loadingdialog = false;
                        this.text1 = this.$t('No-Records-Found')
                        this.snackbar = true
                    }
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.loadingdialog = false;
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.loadingdialog = false;
                    }
                })
            },
            getparabirimi() {
                return helpers.getparabirimi()
            },
            secenekleritemizle() {
                this.filtrecaridegistirView = false
                this.bilettipisatisOnay = false
                this.faturatipifaturalanmamislarOnay = false
    
                this.filtregecicicaridegistirView = false
                this.tekhattpiiOnay = false
                this.gecicarilerOnay = false
    
                this.filtrevoidyapView = false
                this.filtreiadekontrolView = false
                this.bilettipiiadeOnay = false
                this.cariOnay = false
                this.dekontbasOnay = false
                this.giderpusulaOnay = false
                this.iadefaturagelmeyenOnay = false
    
                this.filtrealisfaturaView = false
                this.bilettipisatisiadeOnay = false
                this.acentefatnoOnay = false
    
            },
            /*yenikayit() {
    
                var url = '#/bilet/yeni/id?isl=yeni';
    
                window.open(url, '_self')
    
            },
            */
           yenikayit() {
    this.simpleModeYukle();

    var url = this.simpleMode
        ? '#/bilet/newbilet2/id?isl=yeni'
        : '#/bilet/yeni/id?isl=yeni';

    window.open(url, '_self');
},
            cariservisgetir() {
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));
                this.servisclass.Cari.Kod = this.Bilet.GenelBilgileri.MusteriKodu.Kod
                this.servisclass.SirketKodu = credentials.SirketKodu
                this.servisclass.Hat = this.Bilet.GenelBilgileri.UcusTipi
                this.servisclass.Parkurlar.Parkur1 = this.Bilet.GenelBilgileri.Parkurlar.Parkur1
                this.servisclass.Parkurlar.Parkur2 = this.Bilet.GenelBilgileri.Parkurlar.Parkur2
                this.servisclass.Parkurlar.Parkur3 = this.Bilet.GenelBilgileri.Parkurlar.Parkur3
                this.servisclass.Parkurlar.Parkur4 = this.Bilet.GenelBilgileri.Parkurlar.Parkur4
                this.servisclass.Parkurlar.Parkur5 = this.Bilet.GenelBilgileri.Parkurlar.Parkur5
                this.servisclass.DefaultKontrol = true
    
                var params1 = this.servisclass
    
                this.$http.post(auth.API_URL + 'api/TicketDefinitons/ServiceCodeList', params1, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
    
                    if (response.body.length != 0) {
    
                        this.Bilet.TanimBilgileri.ServisKod = response.body[0].Kod
                        var params = {
                            HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
                            SirketKodu: credentials.SirketKodu,
                            ServisKodBilgi: response.body[0],
                            KurTarih: this.Bilet.TarihBilgileri.SatisTarihi,
                            TutarBilgi: {
                                ServisTutar: this.Bilet.TutarBilgileri.ServisTutar.ServisTutar,
                                BiletTutar: this.Bilet.TutarBilgileri.Tutar.Tutar,
                                VergiTutar: this.Bilet.TutarBilgileri.PtaTutar.PtaTutar + this.Bilet
                                    .TutarBilgileri.AlanVergiTutar
                                    .AlanVergitutar +
                                    this.Bilet.TutarBilgileri.YFFTutar.YFFTutar // mco + alan + ceza + yff
                            }
                        }
    
                        this.$http.post(auth.API_URL + 'api/Helpers/GetServiceCodePrice', params, {
                           headers: auth.getAuthCompaniesInfo()
                        }).then((response) => {
    
                            this.Bilet.TutarBilgileri.IskontoTutar.IskontoTutar = response.body
                                .IskontoTutar
                            this.Bilet.TutarBilgileri.ServisTutar.ServisTutar = response.body
                                .ServisTutar
                        }, (response) => {
                            if (response.status === 0) {
                                this.text1 = 'Service Unavailable-GetServiceCodePrice'
                                this.snackbar = true
                            } else {
                                this.text1 = 'Service Unavailable-GetServiceCodePrice'
                                this.snackbar = true
                            }
                        })
    
                    }
    
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                })
    
            },
    
            biletarasearch(a) {
                this.BiletListele(1, this.siralamatipi, this.kayitadet, false, this.searchliste)
            },
            biletara(a) {
                this.BiletListele(1, this.siralamatipi, this.kayitadet, false, a)
            },
            deneme() {
                this.secilenkayitlar = []
                this.secilenkayitlar = this.secilenkayitlaryedek
    
            },
            alisFaturaNoisle() {
                if (this.$refs.formalisfatura.validate()) {
    
                    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    
                    var biletlistesi = [];
    
                    this.secilenkayitlar.forEach(element => {
                        var yenikayit = {
                            SirketKodu: credentials.SirketKodu,
                            HavayoluKodu: element.GenelBilgileri.HavaYoluKodu,
                            Formno: element.GenelBilgileri.Formno,
                            BiletNo: element.GenelBilgileri.BiletNo,
                            UcusTipi: element.GenelBilgileri.UcusTipi,
                        }
                        biletlistesi.push(yenikayit)
    
                    });
    
                    var params = {
                        Biletler: biletlistesi,
                        AlisFaturaTarih: this.iadefattarih,
                        AlisFaturaNo: this.faturaBelgeNo
                    }
    
                    this.$http.post(auth.API_URL + 'api/Ticket/TicketBuyingInvoiceSave', params, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
    
                         this.text1 = this.$t(response.body.ResponseMessage);
                        this.snackbar = true;
    
                        if (response.body.Status == true) {
                            this.caridialog = false;
                            this.secilenkayitlar = [];
                            this.BiletListele(1, this.siralamatipi, this.kayitadet, true)
    
                        }
    
                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable'
                            this.progress = false
    
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable'
                            this.progress = false
    
                            this.snackbar = true
                        }
                    })
    
                }
    
            },
             biletSirketeKopyala(){
             if (this.$refs.formalisfatura.validate()) {
    
                    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    
                    var biletlistesi = [];
    
                    this.secilenkayitlar.forEach(element => {
                        var yenikayit = {
                            SirketKodu: credentials.SirketKodu,
                            HavayoluKodu: element.GenelBilgileri.HavaYoluKodu,
                            Formno: element.GenelBilgileri.Formno,
                            BiletNo: element.GenelBilgileri.BiletNo,
                            UcusTipi: element.GenelBilgileri.UcusTipi,
                        }
                        biletlistesi.push(yenikayit)
    
                    });
    
                    var params = {
                        Biletler: biletlistesi,
                        Inputlar: this.ListInput,
                        YeniSirket: this.changeCompany,
                        ChangeCopy: true,
                        ServisUcretiTasinmasin: this.servisUcretiTasinmasin,
                        RezervAlanTasinmasin: this.rezervAlanTasinmasin
                    }
    
                    this.$http.post(auth.API_URL + 'api/Ticket/TicketCompanyChangeCopy', params, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
    
                         this.text1 = this.$t(response.body.ResponseMessage);
                        this.snackbar = true;
    
                        if (response.body.Status == true) {
                            this.caridialog = false;
                            this.secilenkayitlar = [];
                            this.BiletListele(1, this.siralamatipi, this.kayitadet, true)
    
                        }
    
                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable'
                            this.progress = false
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable'
                            this.progress = false
                            this.snackbar = true
                        }
                    })
    
                }
            },
            biletSirketDegistir(){
             if (this.$refs.formalisfatura.validate()) {
    
                    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    
                    var biletlistesi = [];
    
                    this.secilenkayitlar.forEach(element => {
                        var yenikayit = {
                            SirketKodu: credentials.SirketKodu,
                            HavayoluKodu: element.GenelBilgileri.HavaYoluKodu,
                            Formno: element.GenelBilgileri.Formno,
                            BiletNo: element.GenelBilgileri.BiletNo,
                            UcusTipi: element.GenelBilgileri.UcusTipi,
                        }
                        biletlistesi.push(yenikayit)
    
                    });
    
                    var params = {
                        Biletler: biletlistesi,
                        Inputlar: this.ListInput,
                        YeniSirket: this.changeCompany,
                        ChangeCopy: false
                    }
    
                    this.$http.post(auth.API_URL + 'api/Ticket/TicketCompanyChangeCopy', params, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
    
                         this.text1 = this.$t(response.body.ResponseMessage);
                        this.snackbar = true;
    
                        if (response.body.Status == true) {
                            this.caridialog = false;
                            this.secilenkayitlar = [];
                            this.BiletListele(1, this.siralamatipi, this.kayitadet, true)
    
                        }
    
                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable'
                            this.progress = false
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable'
                            this.progress = false
                            this.snackbar = true
                        }
                    })
    
                }
            },
             sirketeKopyala(){
               
            this.secenekleritemizle();
                   if (this.secilenkayitlar.length > 0) {
                        this.caridialog = true;
                        this.dialogtype = 'sirketeKopyala';
                       var response3 = JSON.parse(window.localStorage.getItem('credentials'));
    
                        response3.Sirketler.forEach(element => {
                            if (response3.SirketKodu != element.SirketKodu) {
                            this.altsirketler.push(element); 
                            }
    
                        });
                        this.dialogmesaj = " adet bileti seçili şirekete kopyalamak istediğinize emin misiniz?";
                    } else {
                        this.text1 = this.$t('required-select-ticket-continue')
                        this.snackbar = true;
                    }
            },
            sirketDegistir(){
            this.secenekleritemizle();
                   if (this.secilenkayitlar.length > 0) {
                        this.caridialog = true;
                        this.dialogtype = 'sirketDegistir';
                       var response3 = JSON.parse(window.localStorage.getItem('credentials'));
    
                        response3.Sirketler.forEach(element => {
                            if (response3.SirketKodu != element.SirketKodu) {
                            this.altsirketler.push(element); 
                            }
    
                        });
                        this.dialogmesaj = " adet kayıdın şirketini değiştirmek istediğinize emin misiniz?";
                    } else {
                        this.text1 = this.$t('required-select-ticket-continue')
                        this.snackbar = true;
                    }
            },
            sirketDegistirControl(){
                this.sirketDegistirFiltre = true;
            },
            sirketeKopyalaControl(){
                
                 this.sirketeKopyalaFiltre = true;
                
            },
            alisFaturaNokontrol() {
    
                this.secenekleritemizle();
    
                if ((this.ListInput.Filtreler.BiletTipi == 'S' || this.ListInput.Filtreler.BiletTipi == 'I') &&
                    this.ListInput.Filtreler.AcentaFatNo == 2) {
    
                    this.caridegistirBtn = false;
                    this.voidyapBtn = false;
                    this.gecicicaridegistirBtn = false
                    this.iadeekleBtn = false
                    this.alisfaturanoBtn = true
    
                    if (this.secilenkayitlar.length > 0) {
                        this.caridialog = true;
                        this.iadetarih = helpers.getDateNow();
                        this.dialogtype = 'alisfatura';
                        this.dialogmesaj = this.$t('purchase-invoice-for-number-of-records');
    
                    } else {
                        this.text1 = this.$t('required-select-ticket-continue')
                        this.snackbar = true;
                    }
                } else {
                    this.filtrele();
                    this.filtreUyarimesaj = true
                    this.filtrealisfaturaView = true
                    this.filtrecaridegistirView == false
                    this.filtregecicicaridegistirView == false
                    this.filtrevoidyapView == false
                    this.filtreiadekontrolView == false
    
                    if (this.ListInput.Filtreler.BiletTipi == 'S' || this.ListInput.Filtreler.BiletTipi == 'I') {
                        this.bilettipisatisiadeOnay = true
                    } else {
                        this.bilettipisatisiadeOnay = false
                    }
                    this.acentefatnoOnay = true
    
                    this.ListInput.Filtreler.AcentaFatNo = 2
                }
            },
    
            gecicicarikontrol() {
    
                this.secenekleritemizle();
    
                if (this.ListInput.Filtreler.BiletTipi == 'S' && this.ListInput.Filtreler.FaturaStatus == 1 &&
                    this
                    .ListInput.Filtreler.GeciciCari == 2 && this.ListInput.Filtreler.HatTipi != null) {
    
                    this.caridegistirBtn = false;
                    this.voidyapBtn = false;
                    this.gecicicaridegistirBtn = true
                    this.iadeekleBtn = false
                    this.alisfaturanoBtn = false
    
                    if (this.secilenkayitlar.length > 0) {
    
                        this.gecicicaridialog = true;
    
                        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    
                        var params1 = {
                            CompanyCode: credentials.SirketKodu
                        }
    
                        this.$http.post(auth.API_URL + 'api/TicketHelpers/GetReserveName', params1, {
                            headers: {
                                'Authorization': 'Bearer ' + auth.getAuthHeader()
                            }
                        }).then((response) => {
                            this.RezTutarEtiket = response.body
                        }, (response) => {
                            if (response.status === 0) {
                                this.text1 = 'Service Unavailable-class'
                                this.progress = false
                                this.snackbar = true
                            } else {
                                this.text1 = 'Service Unavailable-class'
                                this.progress = false
                                this.snackbar = true
                            }
                        })
    
                        this.$http.post(auth.API_URL + 'api/currency/List', params1, {
                            headers: {
                                'Authorization': 'Bearer ' + auth.getAuthHeader()
                            }
                        }).then((response) => {
                            this.doviztipi = response.body
                        }, (response) => {
                            if (response.status === 0) {
                                this.text1 = 'Service Unavailable-Döviz'
                                this.snackbar = true
                            } else {
                                this.text1 = 'Service Unavailable-Döviz'
                                this.snackbar = true
                            }
                        })
    
                        this.$http.post(auth.API_URL + 'api/BankPos/List', params1, {
                            headers: {
                                'Authorization': 'Bearer ' + auth.getAuthHeader()
                            }
                        }).then((response) => {
                            this.bankapositems = response.body
                            this.progress = false
                        }, (response) => {
                            if (response.status === 0) {
                                this.text1 = 'Service Unavailable-bankpos'
                                this.progress = false
                                this.snackbar = true
                            } else {
                                this.text1 = 'Service Unavailable-bankpos'
                                this.snackbar = true
                                this.progress = false
                            }
                        })
    
                    } else {
                        this.text1 = this.$t('required-select-ticket-continue')
                        this.snackbar = true;
                    }
                } else {
                    this.filtrele();
    
                    this.filtreUyarimesaj = true
                    this.filtregecicicaridegistirView = true
                    this.filtrecaridegistirView == false
    
                    this.filtrevoidyapView == false
                    this.filtreiadekontrolView == false
                    this.filtrealisfaturaView == false
    
                    this.bilettipisatisOnay = true
                    this.faturatipifaturalanmamislarOnay = true
                    this.tekhattpiiOnay = false
                    this.gecicarilerOnay = true
    
                    this.ListInput.Filtreler.BiletTipi = 'S'
                    this.ListInput.Filtreler.FaturaStatus = 1
                    this.ListInput.Filtreler.GeciciCari = 2
                }
            },
    
            iadekontrol() {
                this.secenekleritemizle();
    
                if (this.ListInput.Filtreler.BiletTipi == 'I' && this.ListInput.Filtreler.DekontBas == true &&
                    this
                    .ListInput.Filtreler.CariKod != null && this.ListInput.Filtreler.GiderPusulasi == 2 && this
                    .ListInput.Filtreler.IadeFatura == true) {
    
                    this.caridegistirBtn = false;
                    this.voidyapBtn = false;
                    this.gecicicaridegistirBtn = false
                    this.iadeekleBtn = true
                    this.alisfaturanoBtn = false
    
                    if (this.secilenkayitlar.length > 0) {
                        this.caridialog = true;
                        this.iadetarih = helpers.getDateNow();
                        this.dialogtype = 'iade';
                        this.dialogmesaj =
                            " adet gelen iade kaydına Fatura No işlemek istediğinize emin misiniz?";
    
                    } else {
                        this.text1 = this.$t('required-select-ticket-continue')
                        this.snackbar = true;
                    }
                } else {
                    this.filtrele();
    
                    this.filtreUyarimesaj = true
                    this.filtreiadekontrolView = true
                    this.filtrecaridegistirView == false
                    this.filtregecicicaridegistirView == false
                    this.filtrevoidyapView == false
                    this.filtrealisfaturaView == false
    
                    this.bilettipiiadeOnay = true
    
                    if (this.ListInput.Filtreler.CariKod == null) {
                        this.cariOnay = false
    
                    } else {
                        this.cariOnay = true
    
                    }
    
                    this.dekontbasOnay = true
                    this.giderpusulaOnay = true
                    this.iadefaturagelmeyenOnay = true
                    this.ListInput.Filtreler.BiletTipi = 'I'
                    this.ListInput.Filtreler.DekontBas = true
                    this.ListInput.Filtreler.GiderPusulasi = 2
                    this.ListInput.Filtreler.IadeFatura = true
    
                }
            },
    
            carikontrol() {
                this.secenekleritemizle();
    
                if (this.ListInput.Filtreler.BiletTipi == 'S' && this.ListInput.Filtreler.FaturaStatus == 1 &&
                    this
                    .ListInput.Filtreler.CariKod != null && this.ListInput.Filtreler.CariKod != '') {
                    this.caridegistirBtn = true;
                    this.voidyapBtn = false;
                    this.gecicicaridegistirBtn = false
                    this.iadeekleBtn = false
                    this.alisfaturanoBtn = false
    
                    if (this.secilenkayitlar.length > 0) {
                        this.caridialog = true;
                        this.dialogtype = 'cari';
                        this.dialogmesaj = " adet kaydın cari bilgisini değiştirmek istediğinize emin misiniz?";
                    } else {
                        this.text1 = this.$t('required-select-ticket-continue')
                        this.snackbar = true;
                    }
                } else {
                    this.filtrele();
                    this.filtreUyarimesaj = true
                    this.filtrecaridegistirView = true
                    this.filtregecicicaridegistirView == false
                    this.filtrevoidyapView == false
                    this.filtreiadekontrolView == false
                    this.filtrealisfaturaView == false
                    this.bilettipisatisOnay = true
                    this.faturatipifaturalanmamislarOnay = true
                    this.ListInput.Filtreler.BiletTipi = 'S'
                    this.ListInput.Filtreler.FaturaStatus = 1
    
                }
            },
            voidkontrol() {
                this.secenekleritemizle();
    
                if (this.ListInput.Filtreler.BiletTipi == 'S' && this.ListInput.Filtreler.FaturaStatus == 1) {
    
                    this.caridegistirBtn = false;
                    this.voidyapBtn = true;
                    this.gecicicaridegistirBtn = false
                    this.iadeekleBtn = false
                    this.alisfaturanoBtn = false
    
                    if (this.secilenkayitlar.length > 0) {
                        this.caridialog = true;
                        this.dialogtype = 'void';
                        this.dialogmesaj = this.$t('Are-you-sure-you want-to-void-the-quantity-record');
                        this.voiddate = helpers.getDateNow();
    
                    } else {
                        this.text1 = this.$t('required-select-ticket-continue')
                        this.snackbar = true;
                    }
                } else {
                    this.filtrele();
                    this.filtreUyarimesaj = true
                    this.filtrevoidyapView = true
                    this.filtrecaridegistirView == false
                    this.filtregecicicaridegistirView == false
                    this.filtreiadekontrolView == false
                    this.filtrealisfaturaView == false
    
                    this.bilettipisatisOnay = true
                    this.faturatipifaturalanmamislarOnay = true
                    this.ListInput.Filtreler.BiletTipi = 'S'
                    this.ListInput.Filtreler.FaturaStatus = 1
                }
    
            },
            taksitgetir(v) {
    
                var tumliste = []
                tumliste = this.bankapositems
    
                tumliste.forEach(element => {
    
                    if (element.PosKodu == v) {
    
                        this.taksitsayi = []
                        this.taksitsayi = element.Taksitler
    
                    }
                });
    
            },
            taksitgetirservis(v) {
    
                var tumliste = []
                tumliste = this.bankapositems
    
                tumliste.forEach(element => {
    
                    if (element.PosKodu == v) {
    
                        this.taksitsayiservis = []
                        this.taksitsayiservis = element.Taksitler
                    }
                });
            },
            gecicicariac() {
    
                this.gecicicaridialog = true;
    
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    
                var params1 = {
                    CompanyCode: credentials.SirketKodu
                }
    
                this.$http.post(auth.API_URL + 'api/TicketHelpers/GetReserveName', params1, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.RezTutarEtiket = response.body
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-class'
                        this.progress = false
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-class'
                        this.progress = false
                        this.snackbar = true
                    }
                })
    
                this.$http.post(auth.API_URL + 'api/currency/List', params1, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.doviztipi = response.body
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-Döviz'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-Döviz'
                        this.snackbar = true
                    }
                })
    
                this.$http.post(auth.API_URL + 'api/BankPos/List', params1, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.bankapositems = response.body
                    this.progress = false
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-bankpos'
                        this.progress = false
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-bankpos'
                        this.snackbar = true
                        this.progress = false
                    }
                })
    
            },
            carisor() {
    
                if (this.yenicari != null) {
                    if (this.secilenkayitlar.length > 0) {
    
                        this.caridialog = true;
                        this.dialogtype = 'cari';
                        this.dialogmesaj = this.$t('Are-you-sure-you-want-to-change-the-current-account-of-the-number-of-records');
    
                    } else {
                        this.text1 = this.$t('required-select-ticket-continue')
                        this.snackbar = true;
                    }
    
                } else {
                    this.text1 = this.$t('Please-Select-Current-Code')
                    this.snackbar = true;
                }
            },
            gecicicarisor() {
    
                if (this.geciciyenicari != null) {
                    if (this.secilenkayitlar.length > 0) {
                        this.gecicicaridialogsor = true;
                        this.dialogmesajgecici =" " + this.$t('Are-you-sure-you-want-to-change-the-temporary-current-information-of-the-record')
                            ;
                    } else {
                        this.text1 =this.$t('Please-Select-A-Ticket')
                            
                        this.snackbar = true;
                    }
    
                } else {
                    this.text1 = this.$t('Please-Select-Current-Code')
                    this.snackbar = true;
                }
            },
            getImgUrl(img) {
                return logoo.logoControl(img);
            },
            denemem() {
                this.secilenkayitlar = []
            },
            BiletListele: BiletListele,
            BiletExcelListele:BiletExcelListele,
            filtrekayit: filtrekayit,
            filtreiptal: filtreiptal,
            git: git,
            gitliste: gitliste,
            sayfala: sayfala,
            tarihkontrol: tarihkontrol,
            filtrele: filtrele,
            odemeseklikontrol: odemeseklikontrol,
            vergihesapla: vergihesapla,
            servishesapla: servishesapla,
            carikoddegistir: carikoddegistir,
            gecicicarikoddegistir: gecicicarikoddegistir,
            topluvoidyap: topluvoidyap,
            geleniadefaturisle: geleniadefaturisle
        },

        
        beforeMount: beforeMount,
    
        mounted() {
            this.simpleModeYukle();
            this.el = this.$refs.fab.$el
    
            this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
    
            if (this.sayfayetki.Status == true) {
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));
                this.progress = true
                this.load = true
                this.load1 = false
    
                this.date = helpers.getDateNow()
                this.date2 = helpers.getDateNow()
    
                this.ListInput.SirketKodu = credentials.SirketKodu
                this.ListInput.BaslangicTarihi = this.date
                this.ListInput.BitisTarihi = this.date2
                this.ListInput.Paging.SayfaNo = 1
                this.ListInput.Paging.VeriAdet = 50
                this.ListInput.Paging.SiralamaTip = 'SalesDate'
    
                this.ListInputYedek = this.ListInput;
    
                var Params = this.ListInput;
                this.yedekListInput = this.ListInput;
                this.$http.post(auth.API_URL + 'api/Ticket/TicketList', Params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    if (response.body.length > 0) {
                        // this.itemsticket = response.body
    
                        this.tumunuseckaldir = false;
                        this.secilenkayitlar = [];
                        this.aramayapildi = true;
    
                        if (response.body.length > 0) {
                            this.kayitvarmi = true;
                            this.pagenumber = response.body[0].TotalPage;
                            this.vmodelpagination = true;
                            this.recordcount =  response.body[0].TotalCount +
                                 this.$t('number-records-listed');
                            var editdizi = [];
    
                            response.body.forEach(element => {
    
                                var yenikayit = [];
    
                                yenikayit.FaturaBilgileri = element.FaturaBilgileri;
                                yenikayit.GenelBilgileri = element.GenelBilgileri;
    
                                var tarih = {
                                    SatisTarihi: tarihkontrol(element.TarihBilgileri
                                        .SatisTarihi),
                                    IadeTarihi: tarihkontrol(element.TarihBilgileri.IadeTarihi),
                                    IptalTarihi: tarihkontrol(element.TarihBilgileri
                                        .IptalTarihi)
                                }
    
                                yenikayit.TarihBilgileri = tarih;
    
                               var fatura = {
    FaturaNo: getBiletFaturaNo(element),
    FaturaSeri: element.FaturaBilgileri ? element.FaturaBilgileri.FaturaSeri : null,
    FaturaTarihi: getBiletFaturaTarihi(element),
    FaturaDurumu: getBiletFaturaDurumu(element)
};

yenikayit.FaturaBilgileri = fatura;
    
    
                                var TutarBilgileri = {
                                //     Doviz:element.TutarBilgileri.Doviz,
                                // DovizliTutar: {
                                //     DovizliTutar: element.TutarBilgileri.NetTutar.NetTutarSatisDoviz.toFixed(
                                //             2)
                                //         .replace(
                                //             /(\d)(?=(\d{3})+\.)/g, '$1,')
                                // },
                                    AlanVergiTutar: element.TutarBilgileri.AlanVergiTutar,
                                    CezaTutar: {
                                        CezaTutar: element.TutarBilgileri.CezaTutar.CezaTutar,
                                    },
                                    CharterTutar: element.TutarBilgileri.CharterTutar,
                                    DigerServisTutar: element.TutarBilgileri.DigerServisTutar,
                                    IskontoTutar: element.TutarBilgileri.IskontoTutar,
                                    KaTutar: element.TutarBilgileri.KaTutar,
                                    NetTutar: {
                                        NetTutar: element.TutarBilgileri.NetTutar.NetTutar
                                            .toFixed(
                                                2)
                                            .replace(
                                                /(\d)(?=(\d{3})+\.)/g, '$1,')
                                    },
                                    PtaTutar: element.TutarBilgileri.PtaTutar,
                                    ReserveTutar: element.TutarBilgileri.ReserveTutar,
                                    ServisTutar: {
                                        ServisTutar: element.TutarBilgileri.ServisTutar
                                            .ServisTutar
                                    },
                                    TaxTutar: element.TutarBilgileri.TaxTutar,
                                    Tutar: {
                                        Tutar: element.TutarBilgileri.Tutar.Tutar.toFixed(2)
                                            .replace(
                                                /(\d)(?=(\d{3})+\.)/g, '$1,')
                                    },
                                    YFFTutar: element.TutarBilgileri.YFFTutar,
                                    Vergiler: vergihesapla(element.TutarBilgileri),
                                    ServisBedeli: servishesapla(element.TutarBilgileri)
                                }
    
                                yenikayit.TutarBilgileri = TutarBilgileri;
                                var OdemeBilgileri = {
                                    SatisSekli: odemeseklikontrol(element.OdemeBilgileri
                                        .SatisSekli)
                                }
                                yenikayit.OdemeBilgileri = OdemeBilgileri;
                                editdizi.push(yenikayit)
                            });
    
                            this.filtreticket = editdizi;
                        }
    
                    } else {
                        this.text1 = this.$t('No-Records-Found')
                        this.snackbar = true
                    }
    
                    this.progress = false
                    this.load1 = true
                    this.load = false
    
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.load1 = true
                        this.progress = false
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.load1 = true
                        this.progress = false
                    }
                })
    
            } else {
    
                this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {
    
                    if (sonuc == true) {
    
                        if (this.prevRoute != null) {
                            var url = '#' + this.prevRoute
    
                            window.open(url, '_self')
                        } else {
                            var url = '#/'
                            window.open(url, '_self')
                        }
                    } else {
    
                    }
    
                });
    
            }
        },
        components: {
            loadingcomp,
            kredikartcomp,
            referansmerkezicomp,
            masrafmerkezicomp,
            analizcomp,
            parainput,
            bolumcomp,
            tarihim,
            yetkidialog,
            cariaracomp
        },
        watch: {
            searchliste: function (val) {
    
                if (val.length > 0) {
                    this.searchIcon = "send"
                } else {
                    this.searchIcon = "search"
    
                }
            },
            tumunuseckaldir(valsec) {
    
                if (valsec == true) {
                    this.secilenkayitlar = this.filtreticket
    
                } else {
                    this.secilenkayitlar = []
                }
    
               
            },
    
            'geciciyenicari': function (cari) {
                //  cariservisgetir();
            },
    
            'GeciciCari.SatisSekli': function (value3) {
    
                if (value3 == 'K') {
                    this.bankaposshow = false;
                    this.kredikartshow = false;
                    this.servisposshow = false;
                    this.GeciciCari.KrediKartNo = null;
                    this.GeciciCari.KKCins = null;
                    this.GeciciCari.KKAy = null;
                    this.GeciciCari.KKYil = null;
                    this.GeciciCari.PosKod = null;
                    this.GeciciCari.TaksitKod = null;
                    this.GeciciCari.ServisPosKod = null;
                    this.GeciciCari.ServisTaksitKod = null;
                } else if (value3 == 'P') {
                    this.bankaposshow = false;
                    this.kredikartshow = false;
                    this.servisposshow = false;
                    this.GeciciCari.KrediKartNo = null;
                    this.GeciciCari.KKCins = null;
                    this.GeciciCari.KKAy = null;
                    this.GeciciCari.KKYil = null;
                    this.GeciciCari.PosKod = null;
                    this.GeciciCari.TaksitKod = null;
                    this.GeciciCari.ServisPosKod = null;
                    this.GeciciCari.ServisTaksitKod = null;
                } else if (value3 == 'R') {
                    this.bankaposshow = true;
                    this.kredikartshow = true;
                    this.servisposshow = true;
                } else if (value3 == 'C') {
                    this.bankaposshow = true;
                    this.kredikartshow = true;
                    this.servisposshow = false;
                    this.GeciciCari.ServisPosKod = null;
                    this.GeciciCari.ServisTaksitKod = null;
                } else if (value3 == 'F') {
                    this.bankaposshow = true;
                    this.servisposshow = true;
                    this.kredikartshow = true;
    
                }
    
            },
            sayfalama(value) {
                this.BiletListele(value, this.siralamatipi, this.kayitadet,
                    true)
    
                this.tumunuseckaldir = false
                this.secilenkayitlar = []
    
            },
    
            'siralamatipi': function (valuetip) {
                this.BiletListele(1, valuetip, this.kayitadet, true)
    
            },
            'kayitadet': function (valueveriadet) {
                this.BiletListele(1, this.siralamatipi, valueveriadet, true)
            },
            'ListInput.Filtreler.BiletTipi': function (bt) {
                if (bt == 'S') {
                    this.bilettipisatisOnay = true
                } else {
                    this.bilettipisatisOnay = false
    
                }
    
                if (bt == 'I') {
                    this.bilettipiiadeOnay = true
                } else {
                    this.bilettipiiadeOnay = false
                }
    
                if (bt == 'I' || bt == 'S') {
                    this.bilettipisatisiadeOnay = true
                } else {
                    this.bilettipisatisiadeOnay = false
                }
    
            },
            'ListInput.Filtreler.FaturaStatus': function (fs) {
                if (fs == 1) {
                    this.faturatipifaturalanmamislarOnay = true
                } else {
                    this.faturatipifaturalanmamislarOnay = false
                }
            },
            'ListInput.Filtreler.CariKod': function (cari) {
                if (cari != null && cari != '') {
                    this.cariOnay = true
                } else {
                    this.cariOnay = false
                }
            },
            'ListInput.Filtreler.HatTipi': function (yon) {
    
                if (yon != null && yon != '') {
                    this.tekhattpiiOnay = true
                } else {
                    this.tekhattpiiOnay = false
                }
    
            },
            'ListInput.Filtreler.GeciciCari': function (val) {
                if (val == 2) {
                    this.gecicarilerOnay = true
                } else {
                    this.gecicarilerOnay = false
    
                }
            },
            'ListInput.Filtreler.DekontBas': function (val) {
                if (val == true) {
                    this.dekontbasilanOnay = true
                } else {
                    this.dekontbasilanOnay = false
                }
            },
    
            'ListInput.Filtreler.IadeFatura': function (val) {
                if (val == true) {
                    this.iadefaturasigelmeyenOnay = true
                } else {
                    this.iadefaturasigelmeyenOnay = false
                }
            },
            'ListInput.Filtreler.GiderPusulasi': function (val) {
                if (val == 2) {
                    this.iadebelgedekontOnay = true
                } else {
                    this.iadebelgedekontOnay = false
                }
            },
            'ListInput.Filtreler.AcentaFatNo': function (val) {
                if (val == 2) {
                    this.acentefatnoOnay = true
                } else {
                    this.acentefatnoOnay = false
                }
            },
            gorunumtipi(value2) {
                if (value2 == 'table') {
                    this.tablegorunum = true
                    this.listegorunum = false
                    this.vmodelpagination = false
                    this.listegorunum = false
    
                    this.yedekListInput.Paging.SayfaNo = 0
                    this.yedekListInput.Paging.VeriAdet = null
                    this.yedekListInput.Paging.SiralamaTip = null
    
                    var Params = this.yedekListInput;
                    this.$http.post(auth.API_URL + 'api/Ticket/TicketList', Params, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
    
                        this.itemsticket = response.body
    
                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = this.$t('Error')
                            this.snackbar = true
                            this.load1 = true
                            this.progress = false
                        } else {
                            this.text1 = this.$t('Error')
                            this.snackbar = true
    
                            this.load1 = true
                            this.progress = false
                        }
                    })
    
                } else {
                    this.tablegorunum = false
                    this.listegorunum = true
                    this.vmodelpagination = true
                    this.listegorunum = true
                }
            }
        },
        filters: {
            dateformat: function (t) {
                return helpers.dateformat(t);
            },
            moneyformat: function (m) {
                return helpers.moneyformat(m);
            },
    
            bakiyekontrol: function (m) {
                return helpers.bakiyekontrol(m);
            }
        }
    }

    function plainClone(value) {
    if (value === null || value === undefined) return value;

    if (typeof value !== "object") return value;

    var result = {};

    Object.keys(value).forEach(function (key) {
        result[key] = plainClone(value[key]);
    });

    return result;
}

    async function bulkDownloadPdf() {
    if (!this.secilenkayitlar || this.secilenkayitlar.length == 0) {
        this.text1 = this.$t('required-select-ticket-continue');
        this.snackbar = true;
        return;
    }

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.bulkPdfLoading = true;

    try {
        var secilenler = this.filtreticket.filter(x =>
            this.secilenkayitlar.some(y =>
                y &&
                y.GenelBilgileri &&
                x &&
                x.GenelBilgileri &&
                y.GenelBilgileri.BiletNo == x.GenelBilgileri.BiletNo &&
                y.GenelBilgileri.HavaYoluKodu == x.GenelBilgileri.HavaYoluKodu &&
                y.GenelBilgileri.UcusTipi == x.GenelBilgileri.UcusTipi
            )
        );

        if (!secilenler || secilenler.length == 0) {
            this.text1 = this.$t('required-select-ticket-continue');
            this.snackbar = true;
            return;
        }

        var tickets = [];

        for (var i = 0; i < secilenler.length; i++) {
            var item = secilenler[i];

            var base64 = "";

            try {
                base64 = await this.imageUrlToBase64(
                    this.getImgUrl(item.GenelBilgileri.HavaYoluKodu)
                );
            } catch (e) {
                base64 = "";
            }

            tickets.push({
    SirketKodu: item.GenelBilgileri.SirketKodu,
    BiletNo: item.GenelBilgileri.BiletNo,
    HavaYoluKodu: item.GenelBilgileri.HavaYoluKodu,
    UcusTipi: item.GenelBilgileri.UcusTipi,
    Formno: item.GenelBilgileri.Formno,
    Status: item.GenelBilgileri.Status,
    Logo: base64,
    PdfShowAmount: this.bulkPdfShowAmount,
});
        }

        var params = {
            Tickets: tickets
        };

        const response = await this.$http.post(
            auth.API_URL + 'api/Ticket/BulkTicketPdfDownload',
            params,
            {
                headers: {
                    Authorization: "Bearer " + auth.getAuthHeader(),
                    CariSirketNo: credentials.SirketKodu.toString(),
                    CoperSirketNo: credentials.CoperSirketNo.toString(),
                    MuhasebeSirketNo: credentials.MuhasebeSirketNo.toString(),
                },
                responseType: "arraybuffer"
            }
        );

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');

        link.href = window.URL.createObjectURL(blob);
        link.download = "SelectedTicketInvoices.pdf";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(link.href);

    } catch (error) {
        console.error("Toplu PDF indirilemedi", error);
        this.text1 = this.$t('PDF-could-not-be-downloaded');
        this.snackbar = true;
    } finally {
        this.bulkPdfLoading = false;
    }
}

async function imageUrlToBase64(url) {
    const response = await fetch(url);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;

        reader.readAsDataURL(blob);
    });
}
    
    function filtrekayit() {
        this.filtrevarmi = true;
    
        if (this.filtrecaridegistirView == true) {
            if (this.cariOnay == true && this.bilettipisatisOnay == true && this.faturatipifaturalanmamislarOnay ==
                true) {
                this.caridegistirBtn = true;
                this.voidyapBtn = false;
                this.gecicicaridegistirBtn = false
                this.iadeekleBtn = false
                this.alisfaturanoBtn = false
                this.BiletListele(1, this.siralamatipi, this.kayitadet, false)
                this.dialogfiltre = false
            } else {
                this.voidyapBtn = false;
                this.caridegistirBtn = false
                this.gecicicaridegistirBtn = false
                this.iadeekleBtn = false
                this.alisfaturanoBtn = false
                this.text1 = this.$t('Please-complete-the-filters')
                this.snackbar = true
            }
    
        } else if (this.filtregecicicaridegistirView == true) {
    
            if (this.tekhattpiiOnay == true && this.bilettipisatisOnay == true && this
                .faturatipifaturalanmamislarOnay ==
                true && this.gecicarilerOnay == true) {
    
                this.gecicicaridegistirBtn = true;
                this.voidyapBtn = false;
                this.caridegistirBtn = false
                this.iadeekleBtn = false
                this.alisfaturanoBtn = false
                this.dialogfiltre = false
                this.BiletListele(1, this.siralamatipi, this.kayitadet, false)
            } else {
                this.voidyapBtn = false;
                this.caridegistirBtn = false
                this.gecicicaridegistirBtn = false
                this.iadeekleBtn = false
                this.alisfaturanoBtn = false
                this.text1 = this.$t('Please-complete-the-filters')
                this.snackbar = true
            }
    
        } else if (this.filtrevoidyapView == true) {
    
            if (this.bilettipisatisOnay == true && this.faturatipifaturalanmamislarOnay == true) {
    
                this.voidyapBtn = true;
                this.caridegistirBtn = false
                this.gecicicaridegistirBtn = false
                this.iadeekleBtn = false
                this.alisfaturanoBtn = false
    
                this.dialogfiltre = false
                this.BiletListele(1, this.siralamatipi, this.kayitadet, false)
            } else {
                this.voidyapBtn = false
                this.caridegistirBtn = false
                this.gecicicaridegistirBtn = false
                this.iadeekleBtn = false
                this.alisfaturanoBtn = false
    
                this.text1 = this.$t('Please-complete-the-filters')
                this.snackbar = true
            }
    
        } else if (this.filtreiadekontrolView == true) {
    
            if (this.bilettipiiadeOnay == true && this.cariOnay == true && this.dekontbasOnay == true && this
                .giderpusulaOnay == true && this.iadefaturagelmeyenOnay == true) {
    
                this.iadeekleBtn = true;
                this.caridegistirBtn = false
                this.gecicicaridegistirBtn = false
                this.voidyapBtn = false
                this.alisfaturanoBtn = false
    
                this.dialogfiltre = false
                this.BiletListele(1, this.siralamatipi, this.kayitadet, false)
            } else {
                this.iadeekleBtn = false
                this.caridegistirBtn = false
                this.gecicicaridegistirBtn = false
                this.voidyapBtn = false
                this.alisfaturanoBtn = false
                this.text1 = this.$t('Please-complete-the-filters')
                this.snackbar = true
            }
        } else if (this.filtrealisfaturaView == true) {
    
            if (this.bilettipisatisiadeOnay == true && this.acentefatnoOnay == true) {
    
                this.alisfaturanoBtn = true;
                this.caridegistirBtn = false
                this.gecicicaridegistirBtn = false
                this.voidyapBtn = false
                this.iadeekleBtn = false
                this.dialogfiltre = false
                this.BiletListele(1, this.siralamatipi, this.kayitadet, false)
            } else {
                this.alisfaturanoBtn = false
                this.caridegistirBtn = false
                this.gecicicaridegistirBtn = false
                this.voidyapBtn = false
                this.iadeekleBtn = false
                this.text1 = this.$t('Please-complete-the-filters')
                this.snackbar = true
            }
    
        }
        else if(this.sirketDegistirFiltre == true){
            this.ListInput.Filtreler.FaturaStatus = 1;
            this.BiletListele(1, this.siralamatipi, this.kayitadet, false)
            this.sirketDegistirFiltre = false
            this.sirketDegistirBtn = true;
           
            
    
        }
         else if(this.sirketeKopyalaFiltre == true){
            this.ListInput.Filtreler.FaturaStatus = 1;
            this.BiletListele(1, this.siralamatipi, this.kayitadet, false)
            this.sirketeKopyalaFiltre = false
            this.sirketeKopyalaBtn = true;
           
            
    
        } 
        else {
            this.BiletListele(1, this.siralamatipi, this.kayitadet, false)
            this.dialogfiltre = false
        }
    
    }
    
    function filtreiptal() {
        this.filtrevarmi = false;
        this.ListInput.BiletNo = null;
        this.ListInput.Filtreler.IadeFatura = false;
        this.ListInput.Filtreler.GiderPusulasi = 0;
        this.ListInput.Filtreler.AcentaFatNo = 0;
        this.ListInput.Filtreler.FaturaStatus = 0;
        this.ListInput.Filtreler.GeciciCari = 0;
        this.ListInput.Filtreler.CariKod = null;
        this.ListInput.Filtreler.Havayollari = [];
        this.ListInput.Filtreler.Parkurlar = [];
        this.ListInput.Filtreler.HatTipi = [];
        this.ListInput.Filtreler.BiletTipi = 'S';
        this.ListInput.Filtreler.Ucus1 = null;
        this.ListInput.Filtreler.Ucus2 = null;
        this.ListInput.Filtreler.KesenKisi = null;
        this.ListInput.Filtreler.MasrafMerkezi = null;
        this.ListInput.Filtreler.PosKod = null;
        this.ListInput.Filtreler.KrediKartNo = null;
        this.ListInput.Filtreler.DekontBas = false;
        this.ListInput.Filtreler.BaslangicTutar = 0;
        this.ListInput.Filtreler.YolcuAdi = null;
        this.ListInput.Filtreler.PnrNo = null;
        this.ListInput.Filtreler.BitisTutar = 0;
        this.ListInput.Filtreler.TutarTip = 0;
    
        this.dialogfiltre = false;
        this.filtrealert = false;
    
        this.BiletListele(this.sayfalama, this.siralamatipi, this.kayitadet,
            false)
        this.secilenkayitlar = []
    
        this.filtreUyarimesaj = false
    
        //carikoddeğiştir için bunlar
        this.filtrecaridegistirView = false
        this.bilettipisatisOnay = false
        this.faturatipifaturalanmamislarOnay = false
        this.gecicicaridegistirBtn = false
        this.filtregecicicaridegistirView = false
        this.tekhattpiiOnay = false
        this.gecicarilerOnay = false
        this.caridegistirBtn = false
        this.voidyapBtn = false
        this.filtrevoidyapView = false
        this.filtreiadekontrolView = false
        this.bilettipiiadeOnay = false
        this.cariOnay = false
        this.dekontbasOnay = false
        this.giderpusulaOnay = false
        this.iadefaturagelmeyenOnay = false
        this.iadeekleBtn = false
        this.filtrealisfaturaView = false
        this.bilettipisatisiadeOnay = false
        this.acentefatnoOnay = false
        this.alisfaturanoBtn = false
        this.sirketDegistirBtn = false;
        this.sirketeKopyalaBtn=false;
    }   
    
    function git(v) {
        if (v.GenelBilgileri.Status == 'S' || v.GenelBilgileri.Status == 'Ia') {
            let url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + v.GenelBilgileri.HavaYoluKodu + '&biletno=' + v
                .GenelBilgileri
                .BiletNo + '&ucustipi=' + v.GenelBilgileri.UcusTipi
            window.open(url, '_blank')
        } else if (v.GenelBilgileri.Status == 'V') {
            let url = '#/bilet/yeni/id?' + 'isl=voidget&hyolukod=' + v.GenelBilgileri.HavaYoluKodu + '&biletno=' + v
                .GenelBilgileri
                .BiletNo + '&ucustipi=' + v.GenelBilgileri.UcusTipi
            window.open(url, '_blank')
        }
    }
    
    function gitliste(Status, HavaYoluKodu, BiletNo, UcusTipi) {
        if (Status == 'S' || Status == 'Ia') {
            let url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + HavaYoluKodu + '&biletno=' + BiletNo +
                '&ucustipi=' +
                UcusTipi
            window.open(url, '_blank')
        } else if (Status == 'V') {
            let url = '#/bilet/yeni/id?' + 'isl=voidget&hyolukod=' + HavaYoluKodu + '&biletno=' + BiletNo +
                '&ucustipi=' + UcusTipi
            window.open(url, '_blank')
        }
        this.multipleTicket = false;
    }
    
    function filtrele() {
    
        this.dialogfiltre = true;
    
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    
        var params = {
            CompanyCode: credentials.SirketKodu
        }
    
        this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.itemsairlinelist = response.body
        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.progress = false
    
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable'
                this.progress = false
    
                this.snackbar = true
            }
        })
    
        this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurList', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.itemsparkur = response.body
    
            this.progress = false
        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-parkur'
                this.snackbar = true
                this.progress = false
    
            } else {
                this.text1 = 'Service Unavailable-parkur'
                this.snackbar = true
                this.progress = false
            }
        })
    
        this.$http.post(auth.API_URL + 'api/BankPos/List', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.bankapositems = response.body
            this.progress = false
        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-bankpos'
                this.progress = false
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable-bankpos'
                this.snackbar = true
                this.progress = false
            }
        })
    
    }
    
    function beforeMount() {
    
    }
    
    function gecicicarikoddegistir() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var biletlistesi = [];
       
        if (this.secilenkayitlar.length > 0) {
            this.loadingdialog = true;
            this.geciciCounter += 1;
            if(this.geciciCounter == 1){
            
            var biletlistesi = [];
            this.secilenkayitlar.forEach(element => {
                var yenikayit = {
                    SirketKodu: credentials.SirketKodu,
                    HavayoluKodu: element.GenelBilgileri.HavaYoluKodu,
                    FormNo: element.GenelBilgileri.Formno,
                    BiletNo: element.GenelBilgileri.BiletNo
                }
                biletlistesi.push(yenikayit)
    
            });
             this.GeciciCari.DovizTip = this.GeciciCari.DovizTipi;
    
            
    
            var params = {
                Inputlar: this.ListInputYedek,
                Biletler: biletlistesi,
                YeniCari: this.geciciyenicari,
                Degisikliker: this.GeciciCari
            }
            this.$http.post(auth.API_URL + 'api/Ticket/TicketTempCurrentChange', params, {
                    headers: auth.getAuthCompaniesInfo()
            }).then((response) => {
    
                 this.text1 = this.$t(response.body.ResponseMessage);
                this.snackbar = true;
                this.loadingdialog = false;
                this.geciciCounter = 0;
                if (response.body.Status == true) {
                    this.gecicicaridialogsor = false;
                    this.gecicicaridialog = false;
                    this.secilenkayitlar = [];
                    this.BiletListele(1, this.siralamatipi, this.kayitadet, true)
    
                }
                 this.text1 = this.$t(response.body.ResponseMessage);
                this.snackbar = true;
                this.geciciCounter = 0;
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.progress = false
                    this.snackbar = true
                    this.geciciCounter = 0;
                    this.loadingdialog = false;
                } else {
                    this.loadingdialog = false;
                    this.text1 = 'Service Unavailable'
                    this.progress = false
                    this.snackbar = true
                    this.geciciCounter = 0;
                }
            })
        }
        } else {
            this.text1 = this.$t('required-select-ticket-continue')
            this.snackbar = true;
        }
    
    }
    
    function carikoddegistir() {
        if (this.$refs.formcari.validate()) {
    
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            var biletlistesi = [];
    
            if (this.secilenkayitlar.length > 0) {
                var biletlistesi = [];
    
                this.secilenkayitlar.forEach(element => {
    
                    var yenikayit = {
                        SirketKodu: credentials.SirketKodu,
                        HavayoluKodu: element.GenelBilgileri.HavaYoluKodu,
                        FormNo: element.GenelBilgileri.Formno,
                        BiletNo: element.GenelBilgileri.BiletNo
                    }
                    biletlistesi.push(yenikayit)
    
                });
                var params = {
                    Inputlar: this.ListInput,
                    Biletler: biletlistesi,
                    YeniCari: this.yenicari
                }
                this.$http.post(auth.API_URL + 'api/Ticket/TicketCurrentChange', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                     this.text1 = this.$t(response.body.ResponseMessage);
                    this.snackbar = true;
                    if (response.body.Status == true) {
                        this.caridialog = false
                        this.secilenkayitlar = [];
                        this.BiletListele(1, this.siralamatipi, this.kayitadet, true)
                    }
    
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.progress = false
    
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.progress = false
    
                        this.snackbar = true
                    }
                })
    
            } else {
                this.text1 = this.$t('required-select-ticket-continue')
                this.snackbar = true;
            }
    
        }
    }
    
    function topluvoidyap() {
    
        if (this.$refs.formvoid.validate()) {
    
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            var manage = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
            var biletlistesi = [];
    
            if (this.secilenkayitlar.length > 0) {
    
                var params = {
                    MusteriID: credentials.MusteriID,
                    HareketTip: 'Void',
                    HareketSayisi: this.secilenkayitlar.length
                }
    
                this.$http.post(auth.API_URL + 'api/Register/PackageCustomerInfos', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
    
                    if (response.body.UyelikStatus == true) {
    
                        if (response.body.KontorStatus == true) {
    
                            var biletlistesi = [];
    
                            this.secilenkayitlar.forEach(element => {
    
                                var yenikayit = {
                                    SirketKodu: credentials.SirketKodu,
                                    HavayoluKodu: element.GenelBilgileri.HavaYoluKodu,
                                    FormNo: element.GenelBilgileri.Formno,
                                    BiletNo: element.GenelBilgileri.BiletNo,
                                    UcusTipi: element.GenelBilgileri.UcusTipi,
                                    IssueDate: this.voiddate,
                                    BiletNoSon: null,
                                    Login: {
                                        UserID: manage.UserInfo.UserID,
                                        Email: manage.UserInfo.Email
                                    }
                                }
                                biletlistesi.push(yenikayit)
    
                            });
                            var params = {
                                Inputlar: this.ListInput,
                                Biletler: biletlistesi
                            }
                            this.$http.post(auth.API_URL + 'api/Ticket/VoidMultiAdd', params, {
                                headers: {
                                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                                }
                            }).then((response) => {
    
                                if (response.body.Status == true) {
                                    this.caridialog = false
                                    this.secilenkayitlar = [];
                                    this.voidyapBtn = false
                                    this.BiletListele(1, this.siralamatipi, this.kayitadet, true)
    
                                }
                                 this.text1 = this.$t(response.body.ResponseMessage);
                                this.snackbar = true;
                            }, (response) => {
                                if (response.status === 0) {
                                    this.text1 = 'Service Unavailable-VoidMultiAdd'
                                    this.progress = false
    
                                    this.snackbar = true
                                } else {
                                    this.text1 = 'Service Unavailable-VoidMultiAdd'
                                    this.progress = false
    
                                    this.snackbar = true
                                }
                            })
    
                        } else {
                            this.caridialog = false
    
                            this.text1 = this.$t('not-process-need-purchase-continue-process')
                            this.snackbar = true
                        }
    
                    } else {
                        this.caridialog = false
    
                        this.text1 = this.$t('membership-expired-need-renew-membership-process')
                        this.snackbar = true
                    }
    
                }, (response) => {
    
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-PackageCustomerInfos'
                        this.snackbar = true
                        islemok = false
                    } else {
                        this.text1 = 'Service Unavailable-PackageCustomerInfos'
                        this.snackbar = true
                    }
                })
    
            } else {
                this.text1 = this.$t('required-select-ticket-continue')
                this.snackbar = true;
            }
    
        }
    
    }
    
    function geleniadefaturisle() {
    
        if (this.$refs.formiade.validate()) {
    
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            var manage = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
            var biletlistesi = [];
    
            if (this.secilenkayitlar.length > 0) {
    
                var biletlistesi = [];
    
                this.secilenkayitlar.forEach(element => {
    
                    var yenikayit = {
                        SirketKodu: credentials.SirketKodu,
                        HavayoluKodu: element.GenelBilgileri.HavaYoluKodu,
                        FormNo: element.GenelBilgileri.Formno,
                        BiletNo: element.GenelBilgileri.BiletNo,
                        IadeTarihi: element.TarihBilgileri.IadeTarihi
                    }
                    biletlistesi.push(yenikayit)
    
                });
    
                var params = {
                    Inputlar: this.ListInput,
                    Biletler: biletlistesi,
                    IadeFaturaTarih: this.iadefattarih,
                    IadeFaturaNo: this.faturaBelgeNo,
                    IadeBelgeNo: this.faturaIadeBelgeNo,
                }
    
                this.$http.post(auth.API_URL + 'api/Ticket/RefundInvoiceSave', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
    
                    if (response.body.Status == true) {
                        this.caridialog = false
                        this.secilenkayitlar = [];
    
                        setTimeout(function () {
                            //  this.filtreiptal();
                            this.BiletListele(1, this.siralamatipi, this.kayitadet, true)
                        }.bind(this), 3000)
    
                    }
    
                     this.text1 = this.$t(response.body.ResponseMessage);
                    this.snackbar = true;
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.progress = false
    
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.progress = false
    
                        this.snackbar = true
                    }
                })
    
            } else {
                this.text1 = this.$t('required-select-ticket-continue')
                this.snackbar = true;
            }
        }
    
    }
    
    function sayfala(dizi, baslangic, aralik, indexsayisi, siralamatipi) {
            
        var yenidizi = [];
        this.filtreticket = [];
        var sortdizi = [];
        sortdizi = dizi;
        if (siralamatipi == 0) {
            dizi.sort(function (a, b) {
                return a.TarihBilgileri.SatisTarihi > b.TarihBilgileri.SatisTarihi ? 1 : a.TarihBilgileri
                    .SatisTarihi <
                    b.TarihBilgileri.SatisTarihi ? -1 : 0;
            });
        } else if (siralamatipi == 1) {
            dizi.sort(function (a, b) {
                return b.TarihBilgileri.SatisTarihi > a.TarihBilgileri.SatisTarihi ? 1 : b.TarihBilgileri
                    .SatisTarihi <
                    a.TarihBilgileri.SatisTarihi ? -1 : 0;
            });
    
        } else if (siralamatipi == 2) {
            dizi.sort(function (a, b) {
                return a.GenelBilgileri.BiletNo > b.GenelBilgileri.BiletNo ? 1 : a.GenelBilgileri.BiletNo <
                    b.GenelBilgileri.BiletNo ? -1 : 0;
            });
    
        } else if (siralamatipi == 3) {
    
            dizi.sort(function (a, b) {
                return b.GenelBilgileri.BiletNo > a.GenelBilgileri.BiletNo ? 1 : b.GenelBilgileri.BiletNo <
                    a.GenelBilgileri.BiletNo ? -1 : 0;
            });
    
        } else {
    
            dizi.sort(function (a, b) {
                return a.TarihBilgileri.SatisTarihi > b.TarihBilgileri.SatisTarihi ? 1 : a.TarihBilgileri
                    .SatisTarihi <
                    b.TarihBilgileri.SatisTarihi ? -1 : 0;
            });
    
        }
    
        if (dizi.length > 0) {
    
            this.kayitvarmi = true;
    
            this.pagenumber = Math.ceil(dizi.length / indexsayisi);
    
            yenidizi = dizi.slice(1 * baslangic, (1) * aralik);
    
            var editdizi = [];
    
            yenidizi.forEach(element => {
                var yenikayit = [];
                yenikayit.TutarBilgileri = element.TutarBilgileri;
                yenikayit.FaturaBilgileri = element.FaturaBilgileri;
                yenikayit.GenelBilgileri = element.GenelBilgileri;
                var tarih = {
                    SatisTarihi: tarihkontrol(element.TarihBilgileri.SatisTarihi),
                    IadeTarihi: tarihkontrol(element.TarihBilgileri.IadeTarihi)
                }
                yenikayit.TarihBilgileri = tarih;
    
               var fatura = {
    FaturaNo: getBiletFaturaNo(element),
    FaturaSeri: element.FaturaBilgileri ? element.FaturaBilgileri.FaturaSeri : null,
    FaturaTarihi: getBiletFaturaTarihi(element),
    FaturaDurumu: getBiletFaturaDurumu(element)
};
                yenikayit.FaturaBilgileri = fatura;
                editdizi.push(yenikayit)
            });
            this.filtreticket = editdizi;
        } else {
            this.kayitvarmi = false;
            this.vmodelpagination = false;
        }
    }
    
    function isBosDeger(v) {
    return v === null ||
        v === undefined ||
        String(v).trim() === "" ||
        String(v).trim() === "0";
}

function isBosTarih(v) {
    if (v === null || v === undefined || String(v).trim() === "") {
        return true;
    }

    var s = String(v).trim();

    return s.indexOf("0001-01-01") === 0 ||
        s.indexOf("1900-01-01") === 0;
}

function tarihkontrol(v) {
    if (isBosTarih(v)) {
        return null;
    }

    var text = String(v);
    var parts = text.split("T");
    var dateParts = parts[0].split("-");

    if (dateParts.length !== 3) {
        return text;
    }

    return dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0];
}

function getBiletFaturaNo(element) {
    var faturaBilgileri = element.FaturaBilgileri || {};
    var efaturaBilgileri = faturaBilgileri.EfaturaBilgileri || {};

    if (!isBosDeger(efaturaBilgileri.FaturaNo)) {
        return efaturaBilgileri.FaturaNo;
    }

    if (!isBosDeger(efaturaBilgileri.SanalFaturaNo)) {
        return efaturaBilgileri.SanalFaturaNo;
    }

    if (!isBosDeger(faturaBilgileri.FaturaNo)) {
        if (!isBosDeger(faturaBilgileri.FaturaSeri)) {
            return faturaBilgileri.FaturaSeri + faturaBilgileri.FaturaNo;
        }

        return faturaBilgileri.FaturaNo;
    }

    return null;
}

function getBiletFaturaTarihi(element) {
    var genelBilgileri = element.GenelBilgileri || {};
    var tarihBilgileri = element.TarihBilgileri || {};
    var faturaBilgileri = element.FaturaBilgileri || {};
    var efaturaBilgileri = faturaBilgileri.EfaturaBilgileri || {};

    // İade biletlerde ekranda fatura tarihi olarak B_Satis_Tar gösterilecek.
    // B_Satis_Tar response içinde TarihBilgileri.SatisTarihi olarak geliyor.
    if (genelBilgileri.Status === "Ia" || genelBilgileri.Status === "I") {
        return tarihkontrol(tarihBilgileri.SatisTarihi);
    }

    var tarih = efaturaBilgileri.GercekFaturaTarihi;

    if (isBosTarih(tarih)) {
        tarih = faturaBilgileri.FaturaTarihi;
    }

    return tarihkontrol(tarih);
}

function getBiletFaturaDurumu(element) {
    var faturaBilgileri = element.FaturaBilgileri || {};
    var efaturaBilgileri = faturaBilgileri.EfaturaBilgileri || {};

    return efaturaBilgileri.FaturaDurumu || null;
}

    
    function odemeseklikontrol(v) {
    
        var t=null;
        if (v == "K") {
            t="K-Kredili"  
        } else if (v == "P") {
            t= ("P-Peşin");
        } else if (v == "R") {
            t= ("R-Kartlı");
        } else if (v == "C") {
            t= ("C-Kartlı");
        } else if (v == "F") {
            t= ("F-KrediKartlı");
        } else {
            return null;
        }
    
        return  i18n.tc(t)
    }
    
    function vergihesapla(tutarlar) {
    
        var gosterilecektutar = 0;
    
        gosterilecektutar = tutarlar.AlanVergiTutar.AlanVergiTutar + tutarlar.YFFTutar.YFFTutar + tutarlar.TaxTutar
            .TaxTutar +
            tutarlar.KaTutar.KaTutar;
        gosterilecektutar = Math.round(gosterilecektutar * 100) / 100
    
        return (gosterilecektutar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'))
    }
    
    function servishesapla(tutarlar) {
        var gosterilecektutar = 0;
        gosterilecektutar = tutarlar.ServisTutar.ServisTutar + tutarlar.ReserveTutar.ReserveTutar + tutarlar
            .DigerServisTutar
            .DigerServisTutar - tutarlar.IskontoTutar.IskontoTutar;
    
        gosterilecektutar = Math.round(gosterilecektutar * 100) / 100
        return (gosterilecektutar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'))
    }
    
    function BiletListele(pagenumber, siralamatipi, veriadet, filtre, aranankelime) {
        //anabiletlistele
    
        if (this.$refs.formbiletrapor.validate()) {
    
            var bastarih = new Date(this.date)
            var bittarih = new Date(this.date2)
    
            if (bastarih <= bittarih) {
                this.paginationDisabled = true;
    
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    
                this.progress = true
                this.load1 = false
                this.load = true
    
                if (filtre != true) {
                   
                    this.ListInput.TextSearch = aranankelime
                    this.tumunuseckaldir = false;
                    this.secilenkayitlar = [];
                    this.aramayapildi = true;
                    this.ListInput.SirketKodu = credentials.SirketKodu
                    this.ListInput.BaslangicTarihi = this.date
                    this.ListInput.BitisTarihi = this.date2
                    this.sayfalama = 1;
                    this.ListInput.Paging.SayfaNo = 1
                    //this.ListInput.Paging.VeriAdet = 50
                    this.ListInput.Paging.SiralamaTip = 'SalesDate'
                    this.ListInputYedek = this.ListInput;
                    
    
                } else {
                
                    this.ListInput.TextSearch = null
                    this.searchliste = null
                    this.ListInput = this.ListInputYedek;
                    this.ListInput.Paging.SayfaNo = pagenumber;
                    this.ListInput.Paging.VeriAdet = veriadet;
                    this.ListInput.Paging.SiralamaTip = this.siralamatipi
    
                }
                this.yedekListInput = this.ListInput;
    
                var Params = this.ListInput;
                //Gecici cari degistirme filtrelerinde Hattipi checkbox group olmadigi icin kontrol ediliyor
                if(!Array.isArray(this.ListInput.Filtreler.HatTipi)){
                    var hatTips = [];
                    hatTips.push(this.ListInput.Filtreler.HatTipi);
                    this.ListInput.Filtreler.HatTipi = hatTips;
                }
    
                this.$http.post(auth.API_URL + 'api/Ticket/TicketList', Params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    //  this.itemsticket = response.body
    
                    if (response.body.length > 0) {
                        
                        this.paginationDisabled = false;
                        this.kayitvarmi = true;
                        this.pagenumber = response.body[0].TotalPage;
                        this.vmodelpagination = true;
                        this.recordcount = this.$t('Total') + ' ' + response.body[0].TotalCount +  this.$t('number-records-listed');
                        var editdizi = [];
    
                        response.body.forEach(element => {
    
                            var yenikayit = [];
    
                            yenikayit.FaturaBilgileri = element.FaturaBilgileri;
                            yenikayit.GenelBilgileri = element.GenelBilgileri;
    
                            var tarih = {
                                SatisTarihi: tarihkontrol(element.TarihBilgileri.SatisTarihi),
                                IadeTarihi: tarihkontrol(element.TarihBilgileri.IadeTarihi),
                                IptalTarihi: tarihkontrol(element.TarihBilgileri.IptalTarihi)
                            }
    
                            yenikayit.TarihBilgileri = tarih;
    
                            var fatura = {
    FaturaNo: getBiletFaturaNo(element),
    FaturaSeri: element.FaturaBilgileri ? element.FaturaBilgileri.FaturaSeri : null,
    FaturaTarihi: getBiletFaturaTarihi(element),
    FaturaDurumu: getBiletFaturaDurumu(element)
};

yenikayit.FaturaBilgileri = fatura;
    
                           
                            
                            var TutarBilgileri = {
                                // Doviz:element.TutarBilgileri.Doviz,
                                // DovizliTutar: {
                                //     DovizliTutar: element.TutarBilgileri.NetTutar.NetTutarSatisDoviz.toFixed(
                                //             2)
                                //         .replace(
                                //             /(\d)(?=(\d{3})+\.)/g, '$1,')
                                // },
                                AlanVergiTutar: element.TutarBilgileri.AlanVergiTutar,
                                CezaTutar: {
                                    CezaTutar: element.TutarBilgileri.CezaTutar.CezaTutar,
                                },
                                CharterTutar: element.TutarBilgileri.CharterTutar,
                                DigerServisTutar: element.TutarBilgileri.DigerServisTutar,
                                IskontoTutar: element.TutarBilgileri.IskontoTutar,
                                KaTutar: element.TutarBilgileri.KaTutar,
                                NetTutar: {
                                    NetTutar: element.TutarBilgileri.NetTutar.NetTutar.toFixed(
                                            2)
                                        .replace(
                                            /(\d)(?=(\d{3})+\.)/g, '$1,')
                                },
                                PtaTutar: element.TutarBilgileri.PtaTutar,
                                ReserveTutar: element.TutarBilgileri.ReserveTutar,
                                ServisTutar: {
                                    ServisTutar: element.TutarBilgileri.ServisTutar.ServisTutar
                                },
                                TaxTutar: element.TutarBilgileri.TaxTutar,
                                Tutar: {
                                    Tutar: element.TutarBilgileri.Tutar.Tutar.toFixed(2)
                                        .replace(
                                            /(\d)(?=(\d{3})+\.)/g, '$1,')
                                },
                                YFFTutar: element.TutarBilgileri.YFFTutar,
                                Vergiler: vergihesapla(element.TutarBilgileri),
                                ServisBedeli: servishesapla(element.TutarBilgileri)
                            }
    
                            yenikayit.TutarBilgileri = TutarBilgileri;
                            var OdemeBilgileri = {
                                SatisSekli: odemeseklikontrol(element.OdemeBilgileri.SatisSekli)
                            }
                            yenikayit.OdemeBilgileri = OdemeBilgileri;
                            editdizi.push(yenikayit)
                        });
    
                        this.filtreticket = editdizi;
    
                    } else {
                        this.filtreticket = [];
                        this.kayitvarmi = false;
                        this.vmodelpagination = false;
                        this.recordcount = ""
                        this.text1 = this.$t('No-Records-Found')
                        this.snackbar = true
                    }
    
                    this.progress = false
                    this.load1 = true
                    this.load = false
    
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.load1 = true
                        this.progress = false
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
    
                        this.load1 = true
                        this.progress = false
    
                    }
                })
            } else {
                this.text1 = this.$t('start-date-cannot-greater-than-end-date')
                this.snackbar = true
            }
        }
    }
    
    function BiletExcelListele(pagenumber, siralamatipi, veriadet, filtre, aranankelime) {
        if (this.$refs.formbiletrapor.validate()) {
    
            var bastarih = new Date(this.date)
            var bittarih = new Date(this.date2)
    
            if (bastarih <= bittarih) {
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));
                this.paginationDisabled = true;
    
                this.progress = true
                this.load1 = false
                this.load = true
                if (filtre != true) {
                    this.ListInput.TextSearch = aranankelime
                    this.tumunuseckaldir = false;
                    this.secilenkayitlar = [];
                    this.aramayapildi = true;
                    this.ListInput.SirketKodu = credentials.SirketKodu
                    this.ListInput.BaslangicTarihi = this.date
                    this.ListInput.BitisTarihi = this.date2
                    this.ListInput.Paging.SayfaNo = 1
                    this.ListInput.Paging.VeriAdet = 50
                    this.ListInput.Paging.SiralamaTip = 'SalesDate'
                    this.ListInputYedek = this.ListInput;
    
                } else {
                    this.ListInput.TextSearch = null
                    this.searchliste = null
                    this.ListInput = this.ListInputYedek;
                    this.ListInput.Paging.SayfaNo = pagenumber;
                    this.ListInput.Paging.VeriAdet = veriadet;
                    this.ListInput.Paging.SiralamaTip = this.siralamatipi
    
                }
    
                this.yedekListInput = this.ListInput;
    
                var Params = this.ListInput;
    
                this.$http.post(auth.API_URL + 'api/Ticket/TicketListExcel', Params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    },
                   responseType: "arraybuffer"
                }).then((response) => {
                    var blob = new Blob([response.data], {
                        type: 'application/xlsx'
                    });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "BiletListesi.xlsx";
                    link.click();
                    
                    this.progress = false
                    this.load1 = true
                    this.load = false
    
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.load1 = true
                        this.progress = false
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
    
                        this.load1 = true
                        this.progress = false
    
                    }
                })
            } else {
                this.text1 = this.$t('start-date-cannot-greater-than-end-date')
                this.snackbar = true
            }
        }
    }
    </script>
    
    <style scoped>
    .v-list__tile__content {
        overflow: inherit;
    }
    </style>
    